/* eslint-disable jsx-a11y/alt-text */
import React, { useState, Component } from "react";
import { TimelineDocIcon, TimelineInfoIcon } from "assets/Iconsv2/Iconsv2";
import { Container, OverlayTrigger, Popover, Modal } from "react-bootstrap";
import { Redirect, withRouter } from "react-router-dom";
import "font-awesome/css/font-awesome.min.css";
import { ResolvePopup, InviteUser } from "app/shared/components/Popups";
import DetailTimelineSection from "../constants/detailtimeline";
import DetailCommentSection from "../constants/detailcomment";
import img from "assets/images/no-image2.jpg";
import { Eye, BarChart2 } from "react-feather";
import Url from "app/shared/constants/Url";
import axios from "axios";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import AudioPlayer from "react-h5-audio-player";
import AlertMessage from "app/shared/components/Popups/AlertMessage";
import CheckFormSettingField from "app/shared/utility/CheckFormSettingField";
import CommonDropdown from "app/shared/components/ReportModal/CommonDropdown";
import "react-vertical-timeline-component/style.min.css";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import { Scrollbars } from "react-custom-scrollbars";
import { CarouselComponent } from "app/shared/components/ReusableComponents/Carousel";
import DocumentComponent from "app/views/Nm/Detail/components/detailPage/leftSection/components/documentComponent.js";
import HighBadgeIcon from "assets/sls-icons/Risk Level/High.svg";
import MediumBadgeIcon from "assets/sls-icons/Risk Level/Medium.svg";
import LowBadgeIcon from "assets/sls-icons/Risk Level/Low.svg";
import ExtremeBadgeIcon from "assets/sls-icons/Risk Level/Extreme.svg";
import { TreeUiComponent } from "app/shared/components/ReusableComponents/TreeView";
import {
  convertDateFromTimezone,
  convertDateFromTimezoneIST,
} from "app/shared/utility/tzUtilFunction";
import _, { filter, head } from "lodash";
import {
  Modal as SLDModal,
  Button as SLDButton,
} from "@salesforce/design-system-react";
import UaUcGraph from "app/shared/components/PredictiveAnalysis/UaUcGraph";
import { config } from "config.js";
import CountGraph from "app/views/Graphs/Graphs/CountGraph";
import { Bar } from "react-chartjs-2";
import UaucOpenDetailHelpDrawer from "./UaucOpenDetailHelpDrawer";
import UaucOnHoldDetailHelpDrawer from "./UaucOnHoldDetailHelpDrawer";
import UaucResolvedDetailHelpDrawer from "./UaucResolvedDetailHelpDrawer";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ClideLoader from "app/shared/ui-kit/loader";
import { withTranslation } from "react-i18next";
import AdminSwitch from "react-switch";
import { t } from "i18next";
import { STATUS_OPTIONS } from "app/views/Nm/Detail/constants/constants";
import { UAUC } from "app/shared/constants/ModuleNames";
import { renderToolTip } from "app/shared/utility/formHelper";

const qs = require("qs");

export const badgeEnum = {
  Extreme: ExtremeBadgeIcon,
  "High Critical": ExtremeBadgeIcon,
  High: HighBadgeIcon,
  Medium: MediumBadgeIcon,
  Low: LowBadgeIcon,
  Moderate: MediumBadgeIcon,
};
const mappingName = {
  Division: "divAnalysisList",
  Department: "deptAnalysisList",
  Contractor: "contractorAnalysisList",
  Zone: "zoneAnalysisList",
  Location: "locationAnalysisList",
};
export const getUserProfileDetails = (id, arr = []) => {
  let cache = {};
  return ((id, arr) => {
    if (id in cache) {
      return cache[id];
    } else {
      cache[id] = arr.find((el) => {
        if (el.userId === id || el.employeeId == id) {
          return el;
        }
      });
      return cache[id];
    }
  })(id, arr);
};
class ReportingDetail extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.state = {
      isToggled: false,
      show: false,
      showUser: false,
      reportDetail: [],
      userLists: [],
      soiId: this.props.match.params.id,
      resolveFlag:
        this.props.match.params.flag == "postReview"
          ? "resolve"
          : this.props.match.params.flag,
      reportingScreen: this.props.match.params.flag,
      originFlag: this.props.match.params.origin,
      isCommentApiLoading: false,
      dataLoading: true,
      accordionOpen: true,
      lightboxactive: false,
      uaucStatus: 0,
      subcommentlist: [],
      userData: JSON.parse(localStorage.getItem("userData")),
      comment: 0,
      commentAdd: "",
      replycommentAdd: "",
      commentlist: [],
      allComments: false,
      redirectToReferrer: false,
      assignedDetails: {},
      toggler: false,
      deletePopup: false,
      userLikedPopup: false,
      fsToggler: false,
      userLike: [],
      likeNumber: "",
      imageType:
        this.props.match?.params?.flag == "open"
          ? "evidence"
          : "evidence_resolve",
      escalatedList: [],
      isRiskBased: false,
      controlMeasureList: [],
      showContractor: false,
      showZone: false,
      showLocation: false,
      projectList: [],
      gpcount: [],
      tbtcount: [],
      trainingInternalCount: [],
      trainingExternalCount: [],
      trainingEmployeeCount: [],
      trainingContractorCount: [],
      commentError: false,
      activitydata: [],
      activity_id: null,
      activity_img: "",
      activity_img_name: "",
      activity_pdf: "",
      activity_pdf_name: "",
      activity_video: "",
      activity_video_name: "",
      countModalParams: {
        isOpen: false,
        moduleName: "",
        moduleData: [],
      },
      selectedUaucStatus: { label: "Open", id: "open" },
      apiStatus: "open",
      observationTooltipText:
        "This is a Sensitive Analysis derived from the observations submitted during unsafe acts and unsafe conditions. The identified risks are categorized into three levels — Low, Medium, and High — based on the sentiment of each observation (Positive, Neutral, or Negative), enabling risk based safety insights.",
      selectedDate: null,
      selectedDateSetting: false,
    };
    this.myRef = React.createRef();
    this.openResolve = this.openResolve.bind(this);
    this.openInviteUser = this.openInviteUser.bind(this);
  }
  toggleState = () => {
    this.setState((prevState) => ({
      isToggled: !prevState.isToggled, // Toggle isToggled value
    }));
  };

  showUserLikedPopup = () => {
    this.setState({
      userLikedPopup: true,
    });
  };

  handleClose = () => {
    this.setState({
      userLikedPopup: false,
    });
  };

  openResolve() {
    const show = !this.state.show;
    this.setState({
      show,
    });
  }

  openInviteUser() {
    const showUser = !this.state.showUser;
    this.setState({
      showUser,
    });
  }

  _fetchParamList = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("springToken");

      let requestData = {
        auth_key: token,
        user_id: userId,
      };
      const headers = {
        "Content-Type": "application/json",
      };

      const url = Url.summary.uaucformParameterList;
      const response = await axios.get(url, { params: requestData, headers });

      if (response.data.status === 200) {
        const found = (response.data.data || []).find(
          (item) => item.parameter === "UAUC Status",
        );

        const SelectedDatefound = (response.data.data || []).find(
          (item) => item.parameter === "Previous Date",
        );
        this.setState({
          uaucStatus: found ? found.value : 0,
          //previousDate: SelectedDatefound?.value == 1 ? true : false,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this._setDataLoading(false);
    }
  };

  _fetchProjectListFlag = async () => {
    let requestData = {
      service_id: this.state.reportDetail.service_id,
      module_name: "uauc",
    };

    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPISpring(
        Url.projectListForm,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { showContractor, showZone, showLocation, projectList } =
                prevState;

              projectList = response.data.data;

              // check contractor flag
              const isContractor = projectList.map(
                (item) => item.contractor_flag,
              );
              showContractor = isContractor == 0 ? false : true;
              console.log("isContractor == " + isContractor);

              const isZone = projectList.map((item) => item.zone_location_flag);
              showZone = isZone == 0 ? false : true;
              console.log("isZone == " + isZone);

              const isLocation = projectList.map(
                (item) => item.zone_location_flag,
              );
              showLocation = isLocation == 0 ? false : true;
              console.log("isLocation == " + isLocation);

              return {
                showContractor,
                showZone,
                showLocation,
                projectList,
              };
            });
          }
        })
        .catch((error) => {
          // this._setDataLoading(false);
        });
    });
  };

  _momentDate = (stringDate) => moment(stringDate).toDate();

  async reportDetail() {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    let requestData;
    let headers = {};
    if (this.state.resolveFlag == "resolve") {
      var datailUrl = Url.soiDashboard.springresolveDetailList;
      const formData = new FormData();
      formData.append("auth_key", token);
      formData.append("user_id", userId);
      formData.append("uaucId", this.state.soiId);
      requestData = formData;
      headers["Content-Type"] = "multipart/form-data";
    } else {
      token = localStorage.getItem("springToken");

      var datailUrl = Url.soiDashboard.uaucOpenDetailList;
      const formData = new FormData();
      formData.append("auth_key", token);
      formData.append("user_id", userId);
      formData.append("uaucId", this.state.soiId);

      requestData = formData;
      headers["Content-Type"] = "multipart/form-data";
    }

    await axios
      .post(datailUrl, requestData, {
        headers,
        params: {
          auth_key: token,
          user_id: userId,
        },
      })
      .then(async (response) => {
        if (response.data.status == 200) {
          console.log("API Response:", response.data);
          const apiValue = response.data.data.selectedUaucStatus || "open";

          // Find matching object from STATUS_OPTIONS
          const selectedOption = STATUS_OPTIONS.find(
            (option) => option.id === apiValue,
          );

          console.log(selectedOption, "selectedOption");

          const reportDetailWithEvidence = {
            ...response.data.data,
            evidence_resolve: response.data.data.resolveEvidence,
          };

          const previousDateValue =
            response.data?.data?.form_setting?.setting.find(
              (item) => item.parameter === "Previous Date",
            )?.parameter_value ?? null;

          this.setState({ previousDate: previousDateValue ? true : false });

          let selectedDate = null;
          if (previousDateValue) {
            selectedDate =
              response.data?.data?.previous_date != null
                ? moment(response.data.data.previous_date).format("DD-MM-YYYY")
                : null;
          }

          this.setState(
            {
              reportDetail: reportDetailWithEvidence,
              apiStatus: apiValue,
              selectedUaucStatus: selectedOption || STATUS_OPTIONS[0],
              activity_id: response.data.data.activity_id,
              evidence_resolve: response.data.data.resolveEvidence,
              controlMeasureList: response.data.data.control_measure_list,
              selectedDate: selectedDate,
              gpcount: response.data.data.gp_count?.length
                ? response.data.data.gp_count
                : [{ gp_count: 0 }],
              tbtcount: response.data.data.tbt_count?.length
                ? response.data.data.tbt_count
                : [{ tbt_count: 0 }],
              trainingInternalCount: response.data.data.training_internal_count
                ?.length
                ? response.data.data.training_internal_count
                : [{ training_internal_count: 0 }],
              trainingExternalCount: response.data.data.training_external_count
                ?.length
                ? response.data.data.training_external_count
                : [{ training_external_count: 0 }],
              trainingEmployeeCount: response.data.data.training_employee_count
                ?.length
                ? response.data.data.training_employee_count
                : [{ training_employee_count: 0 }],
              trainingContractorCount: response.data.data
                .training_contractor_count?.length
                ? response.data.data.training_contractor_count
                : [{ training_contractor_count: 0 }],

              // gpcount: response.data.data.gp_count,
              // tbtcount: response.data.data.tbt_count,
              // trainingInternalCount: response.data.data.training_internal_count,
              // trainingExternalCount: response.data.data.training_external_count,
              // trainingEmployeeCount: response.data.data.training_employee_count,
              // trainingContractorCount:
              //   response.data.data.training_contractor_count,
            },
            () => {
              this.fetchReportingPerson(response.data.data.reported_by_id);
              this.getFilteredStatusOptions();
            },
          );
          this.escalatedList();
          this._fetchProjectListFlag();
        }

        this.setState({ dataLoading: false });
      })
      .catch((error) => {
        this.setState({ dataLoading: false });
      });
  }

  fetchActivityDetails = async () => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");

    await axios
      .post(
        Url.activityDetailSpring,
        qs.stringify({
          auth_key: token,
          user_id: userId,
          activity_id: this.state.activity_id,
        }),
      )
      .then(async (response) => {
        if (response.data.status == 200) {
          console.log("API Response:", response.data);

          await this.setState({
            activityData: response.data.data.activity_list,
            activity_img: response.data?.data.activity_list?.[0]?.file_img,
            activity_img_name:
              response.data?.data?.activity_list?.[0]?.file_img_name,
            activity_pdf: response.data?.data?.activity_list[0]?.file_pdf,
            activity_pdf_name:
              response.data?.data?.activity_list?.[0]?.file_pdf_name,
            activity_video: response.data?.data?.activity_list?.[0]?.file_video,
          });
        }
        console.log(
          this.state.activity_id,
          this.state.activity_img,
          "checlcheck",
        );
      })
      .catch((error) => {
        console.log(error);
      });
    console.log(
      this.state.activity_id,
      this.state.activity_img,
      this.state.activitydata,
      "checlcheck",
    );
  };

  async escalatedList() {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");

    let requestData = {
      auth_key: token,
      user_id: userId,
      service_id: this.state.reportDetail.service_id,
      project_id: this.state.reportDetail.project_id,
      oiac_id: this.state.soiId,
      severity: this.state.reportDetail?.severity?.toLowerCase(),
    };

    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPISpring(
        Url.soiDashboard.escalatedList,
        ContentType,
        requestData,
      );

      responseObj
        .then((response) => {
          if (response.data.status == 200) {
            const { reportDetail } = this.state;
            const escaletedIds = [];
            if (response.data.data.list?.length) {
              response.data.data.list.forEach((data) => {
                data.user_list.forEach((user) => {
                  escaletedIds.push(user.id);
                });
              });
            }
            const voilatorIds =
              reportDetail?.incident_person_details.map((el) =>
                parseInt(el?.searched_incident_person_id),
              ) ?? [];
            const assignId = [null, undefined, 0].includes(
              reportDetail?.assigned_user_id,
            )
              ? this.state.userData?.user_id
              : reportDetail?.assigned_user_id;
            const pendingDetailsIds =
              [
                assignId,
                ...reportDetail.invited_user.map((element) => element.userid),
                ...escaletedIds,
                ...voilatorIds,
              ] ?? [];
            if (pendingDetailsIds.length) {
              this.fetchUsersList([...new Set(pendingDetailsIds)]);
            }
            this.setState({
              escalatedList: response.data.data.list,
              isRiskBased: response.data.data.isRiskBased,
            });
          }
          // console.log(this.state.reportDetail)
          this.setState({ dataLoading: false });
        })
        .catch((error) => {
          this.setState({ dataLoading: false });
        });
    });
  }

  removeInviteUser = async (selectedUserId) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    this.setState({ dataLoading: true });

    try {
      const response = await axios.post(
        Url.smDashboard.uaucRemoveInviteUser,
        qs.stringify({
          auth_key: token,
          user_id: userId,
          uaucId: this.state.soiId,
          selectedUserId: selectedUserId,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          params: {
            auth_key: token,
            user_id: userId,
          },
        },
      );
      if (response.data.status === 200) {
        // this.setState({
        //   showUser : false,
        // });

        await this.reportDetail();
        this.setState({ dataLoading: false, showUser: false });

        AlertMessage({
          message: this.props.t("userRemoved"),
          type: "success",
        });
        this.setState({
          showUser: true,
        });
      } else {
        this.setState({ dataLoading: false });

        AlertMessage({
          message: this.props.t("userNotRemoved"),
          type: "error",
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({ dataLoading: false });
    }
  };

  CommentList = async (limitComment = 0) => {
    this.setState({ isCommentApiLoading: true });
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");

    await axios
      .post(
        Url.smDashboard.getCommentsList,
        qs.stringify({
          auth_key: token,
          user_id: userId,
          report_id: this.state.soiId,
          report_type: "soi",
          limit: limitComment,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      )
      .then((response) => {
        if (response.data.status == 200) {
          this.setState({
            commentlist: response.data.data,
            total_number: response.data.total_number,
            comment: 0,
          });
          this.myChatRef.scrollToBottom(0, 0);
        }
      })
      .catch((error) => {})
      .finally(() => this.setState({ isCommentApiLoading: false }));
  };
  subCommentList = async () => {
    this.setState({ isCommentApiLoading: true });
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");

    await axios
      .post(
        Url.smDashboard.dashboarddetailcommentsubcommentlist,
        qs.stringify({
          auth_key: token,
          user_id: userId,
          report_id: this.state.soiId,
          comment_id: this.state.commentId,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      )
      .then((response) => {
        if (response.data.status == 200) {
          this.setState({ subcommentlist: response.data.data, comment: 1 });
        }
      })
      .catch((error) => {})
      .finally(() => this.setState({ isCommentApiLoading: false }));
  };

  _formValidation = async () => {
    const tempObj = this.state;

    await this.setState((prevState) => {
      prevState.commentError = tempObj.commentAdd ? false : true;

      return prevState;
    });
  };

  CommentAdd = async () => {
    await this._formValidation();

    let formErrorStatus;
    for (var propertyName in this.state) {
      if (propertyName.includes("Error")) {
        if (this.state[propertyName]) {
          console.log(propertyName);
          console.log(this.state[propertyName]);
          formErrorStatus = true;
          console.log("erroe");
          return;
        } else {
          formErrorStatus = false;
        }
        console.log(formErrorStatus);
      }
    }

    if (!formErrorStatus) {
      let userId = localStorage.getItem("userId");
      let token = localStorage.getItem("token");

      await axios
        .post(
          Url.smDashboard.addMainComment,
          qs.stringify({
            auth_key: token,
            user_id: userId,
            id: this.state.soiId,
            module: "soi",
            comment: this.state.commentAdd,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          },
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.CommentList();
            this.setState({ commentAdd: "" });
            this.myChatRef.scrollToBottom(0, 0);
            AlertMessage({
              message: this.props.t("commentAdded"),
              type: "success",
            });
          } else {
            AlertMessage({
              message: this.props.t("commentAddFailed"),
              type: "error",
            });
          }
        })
        .catch((error) => {});
    }
  };

  ReplyCommentAdd = async () => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");

    await axios
      .post(
        Url.smDashboard.replyToComment,
        qs.stringify({
          auth_key: token,
          user_id: userId,
          reply_status: this.state.comment,
          comment_reply_id: 0,
          main_comment_id: this.state.commentId,
          comment: this.state.replycommentAdd,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      )
      .then((response) => {
        if (response.data.status == 200) {
          this.subCommentList();
          this.setState({ replycommentAdd: "" });
          this.myChatRef.scrollToBottom(0, 0);
          AlertMessage({
            message: this.props.t("replyAdded"),
            type: "success",
          });
        } else {
          AlertMessage({
            message: this.props.t("replyAddFailed"),
            type: "error",
          });
        }
      })
      .catch((error) => {});
  };

  LikeCommentAdd = async (Cid, ctype) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");

    await axios
      .post(
        Url.smDashboard.addLikeToComment,
        qs.stringify({
          auth_key: token,
          user_id: userId,
          comment_id: Cid,
          comment_type: ctype,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      )
      .then((response) => {
        if (response.data.status == 200) {
          if (this.state.comment == 1) {
            this.subCommentList();
          } else {
            this.CommentList();
          }
          AlertMessage({
            message: this.props.t("commentLiked"),
            type: "success",
          });
        } else {
          AlertMessage({
            message: this.props.t("commentLikeFailed"),
            type: "error",
          });
        }
      })
      .catch((error) => {});
  };

  LikeCommentRemove = async (Cid, Ctype) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");

    await axios
      .post(
        Url.smDashboard.dashboardcontentcommentremoveunlike,
        qs.stringify({
          auth_key: token,
          user_id: userId,
          comment_id: Cid,
          comment_type: Ctype,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      )
      .then((response) => {
        if (response.data.status == 200) {
          if (this.state.comment == 1) {
            this.subCommentList();
          } else {
            this.CommentList();
          }
          AlertMessage({
            message: this.props.t("likedRemove"),
            type: "success",
          });
        } else {
          AlertMessage({
            message: this.props.t("likeRemoveFailed"),
            type: "error",
          });
        }
      })
      .catch((error) => {});
  };

  CommentRemove = async (Cid, ctype) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");
    var reportData = this.state.reportDetail;

    await axios
      .post(
        Url.soiDashboard.soideletecomment,
        qs.stringify({
          auth_key: token,
          user_id: userId,
          service_id: reportData.service_id,
          project_id: reportData.project_id,
          soi_id: this.state.soiId,
          comment_id: Cid,
          comment_type: ctype,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      )
      .then((response) => {
        if (response.data.status == 200) {
          if (this.state.comment == 1) {
            this.subCommentList();
          } else {
            this.CommentList();
          }
          AlertMessage({
            message: this.props.t("commentDeleted"),
            type: "success",
          });
        } else {
          AlertMessage({
            message: this.props.t("commentDeletedFailed"),
            type: "error",
          });
        }
      })
      .catch((error) => {});
  };

  deleteReport = async (SoiId) => {
    let userId = localStorage.getItem("userId");
    let token =
      localStorage.getItem("springToken") || localStorage.getItem("token");
    this.setState({ dataLoading: true });
    const formData = new FormData();
    formData.append("auth_key", token);
    formData.append("user_id", userId);
    formData.append("uaucId", SoiId);
    formData.append("soi_id", SoiId);

    try {
      const response = await axios.delete(Url.soiDashboard.uaucsoiopendelete, {
        params: {
          auth_key: token,
          user_id: userId,
          uaucId: SoiId,
          soi_id: SoiId,
        },
        data: formData,
      });

      if (
        response &&
        response.data &&
        (response.data.status == 200 || response.status == 200)
      ) {
        this.hideModal();
        this.setState({ dataLoading: false });
        AlertMessage({
          message: this.props.t("uaucDeleted"),
          type: "success",
        });
        setTimeout(() => {
          this.setState({ redirectToReferrer: true });
        }, 1000);
      } else {
        this.setState({ dataLoading: false });
        AlertMessage({
          message: this.props.t("uaucDeletedFailed"),
          type: "error",
        });
      }
    } catch (error) {
      console.log(error);
      this.setState({ dataLoading: false });
      AlertMessage({
        message: this.props.t("uaucDeletedFailed"),
        type: "error",
      });
    }
  };

  UserWhoLiked = async () => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");

    await axios
      .post(
        Url.smDashboard.dashboarddetaillikelist,
        qs.stringify({
          auth_key: token,
          user_id: userId,
          report_id: this.state.soiId,
          report_type: "soi",
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      )
      .then((response) => {
        if (response.data.status == 200) {
          this.setState({
            userLike: response.data.data,
            likeNumber: response.data.like_number,
          });
        }
      })
      .catch((error) => {});
  };

  _addUsersToList = async (newUsers) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    const reportId = this.state.soiId;
    //console.log(newUsers);
    var selectedUserIds = [];
    newUsers.map((item, key) => selectedUserIds.push(item.userId));

    var data = {
      auth_key: token,
      user_id: userId,
      uaucId: reportId,
      selectedUserList: selectedUserIds,
    };

    var formBody = [];
    for (var property in data) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(data[property]);

      if (property == "selected_user_id") {
        data[property].map((item, key) =>
          formBody.push(encodedKey + "=" + item),
        );
      } else {
        formBody.push(encodedKey + "=" + encodedValue);
      }
    }
    formBody = formBody.join("&");
    this.setState({ dataLoading: true });

    await axios
      .post(Url.smDashboard.uaucaddInviteUser, formBody, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        params: {
          auth_key: token,
          user_id: userId,
        },
      })

      .then((response) => {
        this.setState({ dataLoading: false });

        if (response.data.status == 200) {
          AlertMessage({ message: this.props.t("userAdded"), type: "success" });
          this.reportDetail();
        } else {
          AlertMessage({
            message: this.props.t("userNotAdded"),
            type: "error",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ dataLoading: false });
      });
  };

  componentDidMount() {
    this.CommentList();
    this._fetchParamList();
    this.reportDetail()
      .then(() => {
        this.fetchActivityDetails();
      })
      .catch((error) => {
        console.error("Error ", error);
      });
    this.UserWhoLiked();
  }

  cancelItem_onClick = () => {
    this.props.history.goBack();
    //window.history.back();
  };

  togglecommentId = async (comment_id) => {
    await this.setState({ commentId: comment_id });
    await this.subCommentList();
  };

  backToMainComment = async () => {
    await this.CommentList();
    await this.setState({ comment: 0, accordionOpen: true });
  };

  showModal = () => {
    this.setState({ deletePopup: true });
  };

  hideModal = () => {
    this.setState({ deletePopup: false });
  };

  comapareTargetDate = (date = "") => {
    if (date) {
      const targetDate = moment(date, "DD/MM/YYYY");
      const today = moment();
      if (targetDate.isSame(today, "day")) {
        return true;
      }
      return false;
    }
  };

  renderTimeLine = (reportData, state) => {
    const { t } = this.props;
    console.log(reportData, "reportData");

    let details = [
      {
        title: <p className="clide-v2-fs-3">{t("reportedDetail")}</p>,
        cardTitle: (
          <div className="d-flex p-1 text-start">
            <img
              src={reportData.reported_by_pic}
              className="clide-v2-profile-img"
              title={reportData.reported_by}
              alt={t("avatar")}
            />
            <div className="p-1 px-3  w-100 mob-pe">
              <div className="col-12 col-md-12 col-lg-12 px-0">
                {t("reportedDate")}{" "}
              </div>
              <div className="clide-v2-title mb-1">
                <label className="">
                  {/* {(reportData.submission_date)}{' '}{reportData?.submission_time} */}
                  {convertDateFromTimezone(reportData.submission_time)}
                </label>
              </div>
            </div>
          </div>
        ),
      },
      {
        title: <p className="clide-v2-fs-3">{t("assignedDetail")}</p>,
        cardTitle: (
          <div className="d-flex p-1 text-start">
            <img
              src={reportData.assigned_user_pic}
              className="clide-v2-profile-img"
              title={reportData.assigned_user}
              alt="avatar"
            />
            <div className="p-1 px-3  w-100 mob-pe">
              <div className="col-12 col-md-12 col-lg-12 px-0">
                {t("assignedDetail")}
              </div>
              <div className="clide-v2-title mb-1">
                <label className="">{`${convertDateFromTimezone(reportData.target_date) || reportData.riskBaseDueDate || "NA"} `}</label>
              </div>
            </div>
          </div>
        ),
      },
      {
        title: <p className="clide-v2-fs-3">{t("closingDetails")}</p>,
        cardTitle: (
          <div className="d-flex p-1 text-start">
            <img
              src={reportData.assigned_user_pic}
              className="clide-v2-profile-img"
              title={reportData.assigned_user}
            />
            <div className="p-1 px-3  w-100 mob-pe">
              <div className="col-12 col-md-12 col-lg-12 px-0">
                {t("closedDate")}{" "}
              </div>
              <div className="clide-v2-title mb-1">
                <label className="">{`${convertDateFromTimezone(reportData.closingDate) || reportData.riskBaseDueDate || "NA"} `}</label>
              </div>
            </div>
          </div>
        ),
        skip: state.resolveFlag == "resolve" ? false : true,
      },
      {
        title: (
          // <p className="clide-v2-fs-3">{`${state.resolveFlag === "open" ? t('overdue') : t('deviation')
          //   } {t('details')}`}</p>
          <p className="clide-v2-fs-3">
            {`${state.resolveFlag === "resolve" ? t("deviation") : t("overdue")} ${t("details")}`}
          </p>
        ),
        cardTitle: (
          <div className="d-flex p-1 text-start">
            <img
              src={reportData.assigned_user_pic}
              className="clide-v2-profile-img"
              title={reportData.assigned_user}
            />
            <div className="p-1 px-3  w-100 mob-pe">
              <div className="col-12 col-md-12 col-lg-12 px-0">
                {state.resolveFlag === "resolve"
                  ? t("deviation")
                  : t("overdue")}
              </div>
              <div className="clide-v2-title mb-1">
                <label className=""> {reportData.overdue} </label>
              </div>
            </div>
          </div>
        ),
        skip:
          reportData.overdue != undefined && reportData?.overdue != 0
            ? false
            : true,
      },
    ];

    if (reportData.invited_user?.length) {
      details = [
        ...details,
        ...reportData.invited_user?.map((image, index) => {
          return {
            title: <p className="clide-v2-fs-3">{t("invitedUsers")}</p>,
            cardTitle: (
              <div className="d-flex p-1 text-start">
                <img
                  className="clide-v2-profile-img"
                  src={image.userpic}
                  alt=""
                  title={image.username}
                />
                <div className="p-1 px-3  w-100 mob-pe">
                  <div className="col-12 col-md-12 col-lg-12 px-0">
                    {t("dateTime")}
                  </div>
                  <div className="clide-v2-title mb-1">
                    <label className="">
                      {convertDateFromTimezoneIST(image.invite_date) ||
                        "NA"}{" "}
                    </label>
                  </div>
                </div>
              </div>
            ),
          };
        }),
      ];
    }
    // if (this.state.escalatedList?.length > 0) {
    //   details = [
    //     ...details,
    //     ...this.state.escalatedList?.map((data) =>
    //       data.user_list.map((user, idx) => {
    //         return {

    //             title: <p className="clide-v2-fs-3">{" "}
    //             {` Escalated  ${data.level_title}`}</p>,
    //             cardTitle: (
    //               <div className="d-flex p-1 text-start">
    //                 <img
    //                 className="clide-v2-profile-img"
    //                 src={user.pic}
    //                 alt=""
    //                 title={user.name}
    //               />
    //                 <div className="p-1 px-3  w-100 mob-pe">
    //                   <div className="col-12 col-md-12 col-lg-12 px-0">
    //                   Name
    //                   </div>
    //                   <div className="clide-v2-title mb-1">
    //                     <label className="">
    //                     {user.name}{" "}
    //                     </label>
    //                   </div>
    //                 </div>
    //                 <div className="p-1 px-3  w-100 mob-pe">
    //                   <div className="col-12 col-md-12 col-lg-12 px-0">
    //                   Date & Time
    //                   </div>
    //                   <div className="clide-v2-title mb-1">
    //                     <label className="">
    //                     {" "}
    //                   {data.escalatedDate} {data.escalatedTime}
    //                     </label>
    //                   </div>
    //                 </div>
    //               </div>
    //             ),
    //             skip:
    //             (reportData.overdue != undefined && reportData?.overdue != 0) ||
    //               (reportData.deviation != undefined &&
    //                 reportData?.deviation != 0)
    //               ? false
    //               : true,

    //         };
    //       })
    //     ),
    //   ];
    // }
    if (state.commentlist?.length) {
      const { comment, comment_time, user_name, user_pic } =
        state.commentlist[0] ?? {};
      details = [
        ...details,
        {
          title: <p className="clide-v2-fs-3">{t("latestComment")}</p>,
          cardTitle: (
            <div className="d-flex p-1 text-start">
              <img
                src={user_pic}
                className="clide-v2-profile-img"
                title={user_name}
              />
              <div
                className="p-1 px-3  w-100 mob-pe"
                onClick={() => {
                  this.myRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }}
              >
                <div className="col-12 col-md-12 col-lg-12 px-0">Message</div>
                <div
                  className="clide-v2-title mb-1"
                  style={{ display: "grid" }}
                >
                  <label className="">
                    {comment.length > 50
                      ? `${comment.slice(0, 50)}...`
                      : comment}
                  </label>
                  <label className="">{comment_time}</label>
                </div>
              </div>
            </div>
          ),
          skip:
            (reportData.overdue != undefined && reportData?.overdue != 0) ||
            (reportData.deviation != undefined && reportData?.deviation != 0)
              ? false
              : true,
        },
      ];
    }

    return details?.filter((el) => !el?.skip);
  };
  __generateCarouselData = (items = []) => {
    const content = [];

    items.forEach((data) => {
      if (data?.format !== "application/octet-stream") {
        content.push({
          id: data?.id,
          aiStatus: data?.ai_status,
          aiImage: data?.ai_image,
          aiRemark: data?.ai_remark,
          aiResponse: JSON.parse(data?.ai_response || "{}"),
          comment: data?.comment,
          url: data.link,
          contentType:
            data.format != "text"
              ? data.format == "image" ||
                data.format == "img" ||
                data.format == "image/png" ||
                data.format == "image/jpeg" ||
                data.format == "image/jpg"
                ? "image"
                : "video"
              : "video",
        });
      }
    });
    return content;
  };

  __generateTreeNodes = (data = [], activeNode = "") => {
    // Ensure activeNode is a string
    const nodes = typeof activeNode === "string" ? activeNode.split(" ") : [];

    const treeNodes = [];

    // Ensure data is an array before processing
    if (Array.isArray(data)) {
      data.forEach((item) => {
        const label =
          item.level_title === nodes[0]?.trim() ? activeNode : item.level_title;

        treeNodes.push({
          label,
          date: `${item.escalatedDate || ""} ${item.escalatedTime || ""}`,
          children: item.user_list || [],
        });
      });
    }

    return treeNodes;
  };

  _typeactChangeHandle = async (event) => {
    const selectedValue = event;
    const selectedOption = STATUS_OPTIONS.find(
      (option) => option.value === selectedValue,
    );

    this.setState({ selectedUaucStatus: selectedOption }, () => {
      console.log("Updated selectedUaucStatus:", this.state.selectedUaucStatus);
    });
    if (event == "") {
      return;
    }
    this.setState({ dataLoading: true });

    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");

    const formData = new FormData();
    formData.append("auth_key", token);
    formData.append("user_id", userId);
    formData.append("uaucId", this.state.soiId);
    formData.append("status", selectedValue);

    try {
      const response = await axios.put(
        Url.soiDashboard.uaucStatusUpdate,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: {
            auth_key: token,
            user_id: userId,
          },
        },
      );

      if (response.data.status === 200) {
        const selectedOption = STATUS_OPTIONS.find(
          (option) => option.id === selectedValue,
        );

        this.setState({
          apiStatus: selectedValue,
          selectedUaucStatus: selectedOption || STATUS_OPTIONS[0],
        });

        AlertMessage({
          message: "Status updated successfully!",
          type: "success",
        });
      } else {
        AlertMessage({
          message: "Failed to update status. Please try again.",
          type: "error",
        });
      }
    } catch (error) {
      console.error("Error updating status:", error);
      AlertMessage({
        message: "Failed to update status. Please try again.",
        type: "error",
      });
    } finally {
      this.setState({ dataLoading: false });
    }
  };

  // Filter options based on API status (New → WIP → On Hold → WIP → Closed)
  getFilteredStatusOptions = () => {
    const { apiStatus } = this.state;

    if (apiStatus === "open")
      return STATUS_OPTIONS.filter((s) =>
        ["open", "wip", "onhold"].includes(s.id),
      );
    if (apiStatus === "wip")
      return STATUS_OPTIONS.filter((s) =>
        ["open", "wip", "onhold"].includes(s.id),
      );
    if (apiStatus === "onhold")
      return STATUS_OPTIONS.filter((s) =>
        ["open", "wip", "onhold"].includes(s.id),
      );
    if (apiStatus === "close")
      return STATUS_OPTIONS.filter((s) => ["close"].includes(s.id));
    return [];
  };

  __renderTreeTemplate = (parent, children) => {
    return (
      <div
        className="feild-group border-layout-4 px-2 py-2 rounded-0 shadow-none text-center "
        style={{ maxWidth: "230px" }}
      >
        <div className="border rounded py-2 ">
          <span className="clide-v2-fs-4 font-weight-bold">
            {children.name}
          </span>
          <div className="image-box my-3" style={{ marginRight: "0.5rem" }}>
            <GetPopoverFrame
              element={
                <>
                  <img
                    src={children.pic}
                    alt=""
                    className="cursor-p clide-v2-profile-img"
                  />
                </>
              }
              mappingKeys={() => {
                const detail =
                  getUserProfileDetails(children?.id, this.state.userLists) ??
                  {};
                return {
                  [t("id")]: detail["employeeId"] ?? "NA",
                  [t("department")]: detail["field"]?.split(":")[1] ?? "NA",
                  [t("type")]: detail["userType"] ?? "NA",
                  [t("designation")]: detail["designation"] ?? "NA",
                  [t("contact")]: detail["contact_number"] ?? "NA",
                  // Zone: detail['designation'],
                  // Location: detail['designation'],
                };
              }}
            />
          </div>
          <div className="feild-group d-flex justify-content-center">
            <div className=" clide-v2-fs-5">{parent.date}</div>
          </div>
        </div>
      </div>
    );
  };
  fetchReportingPerson = (id) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("springToken");

    axios
      .post(
        Url.springClientURL + "/user/reportedpersonprofile",
        qs.stringify({
          auth_key: token,
          user_id: userId,
          reported_per_id: id,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      )
      .then((res) => {
        this.setState({
          assignedDetails: res.data.data,
        });
      })
      .catch((err) => console.log(err));
  };
  fetchUsersList = async (ids = []) => {
    let databody = new FormData();
    const userList = ids.filter((el) => {
      return el !== null && !Number.isNaN(el);
    });
    if (!userList.length) {
      return false;
    }
    databody.append("auth_key", localStorage.getItem("token"));
    databody.append("user_id", localStorage.getItem("userId"));
    databody.append("user_id_list", userList);
    await axios
      .post(Url.usersList, databody, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => {
        if (response.data.status == 200) {
          this.setState({
            userLists: response.data?.listUserProfileDetailsData,
          });
        } else {
        }
      })
      .catch((error) => {});
  };

  CountDoughnut = (data) => {
    return data.length > 0 ? (
      <div style={{ justifyContent: "center" }}>
        <UaUcGraph
          title=""
          graphData={data}
          list={false}
          height={75}
          cutout={"55%"}
          radius={"100%"}
        />
      </div>
    ) : null;
  };

  debounceFunc = _.debounce(function (callback) {
    callback();
  }, 300);

  onViewCountDetails = (moduleName = "") => {
    this.setState({
      countModalParams: {
        isOpen: true,
        moduleName,
        moduleData: this.state.reportDetail[mappingName[moduleName]],
      },
    });
  };
  generateBarData = (data = []) => {
    return {
      data: {
        labels: data.map((item) => item.name),
        datasets: [
          {
            label: "Open Count",
            data: data.map((item) => item.open_count),
            backgroundColor: data.map((item) => item.openCntcolor),
            color: "white",
          },
          {
            label: "Close Count",
            data: data.map((item) => item.close_count),
            backgroundColor: data.map((item) => item.closeCntcolor),
            color: "white",
          },
        ],
      },
    };
  };

  render() {
    const { t } = this.props;

    const barGraphOptions = {
      responsive: true,
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
        tooltip: {
          backgroundColor: "white",
          bodyColor: "#666666",
          bodyFont: {
            weight: 500,
          },
          borderColor: "rgba(0, 0, 0, 0.08)",
          borderWidth: 2,
          cornerRadius: 4,
          bodySpacing: 4,
          padding: {
            top: -10,
            bottom: 8,
            left: 0,
            right: 0,
          },
          bodyAlign: "center",
          displayColors: false,
          titleColor: "transparent",
        },
        datalabels: {
          display: true,
          align: "top",
          anchor: "end",
          color: "black",
        },
      },
      scales: {
        x: {
          display: true,
          offset: true,
          grid: {
            display: false,
          },
          ticks: {
            color: "#666666",
            font: {
              size: 11,
              weight: "500",
            },
            padding: 0,
          },
        },
        y: {
          display: true,
          beginAtZero: true,
          grid: {
            color: "#ececec",
          },
          ticks: {
            color: "#666666",
            font: {
              size: 11,
              weight: "500",
            },
            padding: 20,
          },
        },
      },
    };

    var reportData = this.state.reportDetail;
    var sourcesList = [];
    var sourcesType = [];
    var inputMessageFlag = 0;
    const { userData } = this.state;
    const { selectedUaucStatus } = this.state;
    const filteredOptions = this.getFilteredStatusOptions();
    const isReportedUserEnabled =
      reportData.reported_by_id === userData.user_id;
    const isApproveEnabled = [3, 1, 5].includes(userData?.designation_flag);

    console.log("form_setting === ", reportData.form_setting?.setting);

    if (this.state.dataLoading == false) {
      var evidencePics =
        this.state.reportDetail && this.state.reportDetail?.evidence
          ? this.state.reportDetail.evidence.map((item) => {
              return {
                url: item.link,
                type: item.format,
              };
            })
          : [];

      if (
        this.state.imageType &&
        this.state.imageType == "evidence" &&
        this.state.reportDetail.evidence
      ) {
        sourcesList = this.state.reportDetail.evidence?.map(
          (item) => item.link,
        );
      } else {
        sourcesList = this.state.reportDetail?.evidence_resolve?.map(
          (item) => item.link,
        );
      }

      if (this.state.imageType && this.state.imageType == "evidence") {
        sourcesType = this.state.reportDetail?.evidence?.map(
          (item) => item.format,
        );
      } else {
        const sourcesType = (
          this.state.reportDetail?.evidence_resolve || []
        ).map((item) =>
          item.format === "img" || item.format === "image/png"
            ? "image"
            : item.format,
        );
      }
    }

    if (this.state.redirectToReferrer) {
      return <Redirect to={`/ua-uc/open`} />;
    }

    let uaUcChartData = [];
    if (this.state.reportDetail?.ua_number != undefined) {
      uaUcChartData = [
        {
          y: reportData?.ua_number,
          name: "Unsafe Act",
          color: "#C7AC83",
        },
        {
          y: reportData?.uc_number,
          name: "Unsafe Condition",
          color: "#554040",
        },
      ];
    }

    const uaUcChart = {
      chart: {
        type: "pie",
        height: "100%",
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      title: null,
      yAxis: {
        title: {
          enabled: false,
        },
      },
      plotOptions: {
        pie: {
          shadow: false,
          showInLegend: true,
        },
      },
      tooltip: {
        formatter: function () {
          return "<b>" + this.point.name + "</b>: " + this.y;
        },
      },
      series: [
        {
          data: [
            { y: reportData.ua_number, name: "Unsafe Act", color: "#C7AC83" },
            {
              y: reportData.uc_number,
              name: "Unsafe Condition",
              color: "#554040",
            },
          ],
          size: "100%",
          innerSize: "56%",
          dataLabels: {
            enabled: false,
          },
        },
      ],
    };

    let data = [
      {
        y: reportData.extreme_number,
        color: reportData.extreme_number_color,
        name: "Extreme",
      },
      {
        y: reportData.high_number,
        color: reportData.high_number_color,
        name: "HIGH",
      },
      {
        y: reportData.medium_number,
        color: reportData.medium_number_color,
        name: "MEDIUM",
      },
      {
        y: reportData.low_number || 0,
        color: reportData.low_number_color,
        name: "LOW",
      },
    ];

    const severityChartData = {
      labels: ["Extreme", "High", "Medium", "Low"],
      datasets: [
        {
          label: "",
          maxBarThickness: 30,
          backgroundColor: data.map((data) => data.color),
          data: data.map((data) => data.y),
        },
      ],
    };

    const severityChart = {
      chart: {
        type: "column",
        height: 150,
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      title: null,
      xAxis: {
        categories: ["Extreme", "High", "Medium", "Low"],
        lineColor: "#000000",
      },
      yAxis: {
        min: 0,
        // max: 5,
        tickInterval: 1,
        title: {
          enabled: false,
        },
        allowDecimals: false,
        gridLineColor: "rgba(0, 0, 0, 0.04)",
      },
      tooltip: {
        formatter: function () {
          return "<b>" + this.point.name + "</b>: " + this.y;
        },
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: "{point.y}",
          },
        },
      },
      series: [
        {
          data: [
            {
              y: reportData.extreme_number,
              color: reportData.extreme_number_color,
              name: "Extreme",
            },
            {
              y: reportData.high_number,
              color: reportData.high_number_color,
              name: "HIGH",
            },
            {
              y: reportData.medium_number,
              color: reportData.medium_number_color,
              name: "MEDIUM",
            },
            {
              y: reportData.low_number || 0,
              color: reportData.low_number_color,
              name: "LOW",
            },
          ],
        },
      ],
    };

    let nmuaUcChartData = [];

    if (this.state.reportDetail?.nm_ua_number != undefined) {
      nmuaUcChartData = [
        {
          y: reportData?.nm_ua_number,
          name: "Unsafe Act",
          color: reportData?.nm_ua_color,
        },
        {
          y: reportData?.nm_uc_number,
          name: "Unsafe Condition",
          color: reportData?.nm_uc_color,
        },
      ];
    }

    const nmuaUcChart = {
      chart: {
        type: "pie",
        height: "100%",
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      title: null,
      yAxis: {
        title: {
          enabled: false,
        },
      },
      plotOptions: {
        pie: {
          shadow: false,
          showInLegend: true,
        },
      },
      tooltip: {
        formatter: function () {
          return "<b>" + this.point.name + "</b>: " + this.y;
        },
      },
      series: [
        {
          data: [
            {
              y: reportData.nm_ua_number,
              name: "Unsafe Act",
              color: reportData.nm_ua_color,
            },
            {
              y: reportData.nm_uc_number,
              name: "Unsafe Condition",
              color: reportData.nm_uc_color,
            },
          ],
          size: "100%",
          innerSize: "56%",
          dataLabels: {
            enabled: false,
          },
        },
      ],
    };

    let analysisChartData = [];
    if (this.state.reportDetail?.activityAnalysis != undefined) {
      analysisChartData = [
        {
          y: reportData?.fa_number ?? 0,
          name: "FA",
          color: "#FF4242",
        },
        {
          y: reportData?.rta_number ?? 0,
          name: "RTA",
          color: "#FAAC15",
        },
        {
          y: reportData?.mtc_number ?? 0,
          name: "MTC",
          color: "#086992",
        },
        {
          y: reportData?.lti_number ?? 0,
          name: "LTI",
          color: "#18DA07",
        },
        {
          y: reportData.activityAnalysis?.first_aid_number ?? 0,
          name: "First Aid",
          color: "#1589EE",
        },
        {
          y: reportData.activityAnalysis?.occupational_illness_number ?? 0,
          name: "OI",
          color: "#C511FF",
        },
        {
          y: reportData.activityAnalysis?.notable_number || 0,
          name: "Notable",
          color: "rgb(161, 255, 206)",
        },
      ];
    }

    const analysisChart = {
      chart: {
        type: "pie",
        height: "100%",
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      title: null,
      yAxis: {
        title: {
          enabled: false,
        },
      },
      plotOptions: {
        pie: {
          shadow: false,
          showInLegend: true,
        },
      },
      tooltip: {
        formatter: function () {
          return "<b>" + this.point.name + "</b>: " + this.y;
        },
      },
      series: [
        {
          data: [
            { y: reportData.fa_number, name: "FA", color: "#FF4242" },
            { y: reportData.rta_number, name: "RTA", color: "#FAAC15" },
            { y: reportData.mtc_number, name: "MTC", color: "#086992" },
            { y: reportData.lti_number, name: "LTI", color: "#18DA07" },
            {
              y: reportData.activityAnalysis?.notable_number || 0,
              name: "Notable",
              color: "#rgb(161, 255, 206)",
            },
            {
              y: reportData.activity_analysis?.first_aid_number || 0,
              name: "First Aid",
              color: "#1589EE",
            },
            {
              y: reportData.activity_analysis?.occupational_illness_number || 0,
              name: "OI",
              color: "#C511FF",
            },
          ],
          size: "100%",
          innerSize: "56%",
          dataLabels: {
            enabled: false,
          },
        },
      ],
    };

    //GP Count
    const gpCount = {
      chart: {
        type: "pie",
        height: "100%",
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      title: {
        useHTML: true,
        text:
          '<span style="color:' +
          "#000" +
          "; font-weight:" +
          "bold" +
          "; font-size: " +
          "2rem" +
          "; text-align:" +
          "center" +
          '; height: 36">' +
          this.state.gpcount.map((data) => data.gp_count) +
          "</span>",
        verticalAlign: "middle",
      },
      yAxis: {
        title: {
          enabled: false,
        },
      },
      plotOptions: {
        pie: {
          shadow: false,
          borderWidth: 0,
          dataLabels: {
            enabled: false,
          },
        },
      },
      colors: this.state.gpcount.map((data) => data.color),
      series: [
        {
          data: [this.state.gpcount.map((data) => data.gp_count)],
          size: "100%",
          innerSize: "84%",
        },
      ],
    };

    //tbtCount
    const tbtCount = {
      chart: {
        type: "pie",
        height: "100%",
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      title: {
        useHTML: true,
        text:
          '<span style="color:' +
          "#000" +
          "; font-weight:" +
          "bold" +
          "; font-size: " +
          "2rem" +
          "; text-align:" +
          "center" +
          '; height: 36">' +
          this.state.tbtcount.map((data) => data.tbt_count) +
          "</span>",
        verticalAlign: "middle",
      },
      yAxis: {
        title: {
          enabled: false,
        },
      },
      plotOptions: {
        pie: {
          shadow: false,
          borderWidth: 0,
          dataLabels: {
            enabled: false,
          },
        },
      },
      colors: this.state.tbtcount.map((data) => data.color),
      series: [
        {
          data: [this.state.tbtcount.map((data) => data.tbt_count)],
          size: "100%",
          innerSize: "84%",
        },
      ],
    };

    const intetlCount = this.state.trainingInternalCount?.length
      ? this.state.trainingInternalCount.map(
          (data) => data.training_internal_count,
        )
      : 0;
    //InternalCOunt
    const internalCount = {
      chart: {
        type: "pie",
        height: "100%",
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      title: {
        useHTML: true,
        text:
          '<span style="color:' +
          "#000" +
          "; font-weight:" +
          "bold" +
          "; font-size: " +
          "2rem" +
          "; text-align:" +
          "center" +
          '; height: 36">' +
          intetlCount +
          "</span>",
        verticalAlign: "middle",
      },
      yAxis: {
        title: {
          enabled: false,
        },
      },
      plotOptions: {
        pie: {
          shadow: false,
          borderWidth: 0,
          dataLabels: {
            enabled: false,
          },
        },
      },
      colors: this.state.trainingInternalCount.map((data) => data.color),
      series: [
        {
          data: [
            this.state.trainingInternalCount?.length
              ? this.state.trainingInternalCount.map(
                  (data) => data.training_internal_count,
                )
              : "0",
          ],
          size: "100%",
          innerSize: "84%",
        },
      ],
    };
    const externalC = this.state.trainingExternalCount?.length
      ? this.state.trainingExternalCount.map(
          (data) => data.training_external_count,
        )
      : 0;
    //externalcount
    const externalCount = {
      chart: {
        type: "pie",
        height: "100%",
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      title: {
        useHTML: true,
        text:
          '<span style="color:' +
          "#000" +
          "; font-weight:" +
          "bold" +
          "; font-size: " +
          "2rem" +
          "; text-align:" +
          "center" +
          '; height: 36">' +
          //  this.state.trainingExternalCount.map((data) => data.training_external_count) +
          externalC +
          "</span>",
        verticalAlign: "middle",
      },
      yAxis: {
        title: {
          enabled: false,
        },
      },
      plotOptions: {
        pie: {
          shadow: false,
          borderWidth: 0,
          dataLabels: {
            enabled: false,
          },
        },
      },
      colors: this.state.trainingExternalCount.map((data) => data.color) ?? [],
      series: [
        {
          // data: [this.state.trainingExternalCount.map((data) => data.training_external_count)],
          data: [
            this.state.trainingExternalCount.length > 0
              ? this.state.trainingExternalCount.map(
                  (data) => data.training_external_count,
                )
              : 0,
          ],
          size: "100%",
          innerSize: "84%",
        },
      ],
    };

    //employeeCount
    const employeeCount = {
      chart: {
        type: "pie",
        height: "100%",
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      title: {
        useHTML: true,
        text:
          '<span style="color:' +
          "#000" +
          "; font-weight:" +
          "bold" +
          "; font-size: " +
          "2rem" +
          "; text-align:" +
          "center" +
          '; height: 36">' +
          this.state.trainingEmployeeCount.map(
            (data) => data.training_employee_count,
          ) +
          "</span>",
        verticalAlign: "middle",
      },
      yAxis: {
        title: {
          enabled: false,
        },
      },
      plotOptions: {
        pie: {
          shadow: false,
          borderWidth: 0,
          dataLabels: {
            enabled: false,
          },
        },
      },
      colors: this.state.trainingEmployeeCount.map((data) => data.color),
      series: [
        {
          data: [
            this.state.trainingEmployeeCount.map(
              (data) => data.training_employee_count,
            ),
          ],
          size: "100%",
          innerSize: "84%",
        },
      ],
    };

    //contractorCount
    const contractorCount = {
      chart: {
        type: "pie",
        height: "100%",
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      title: {
        useHTML: true,
        text:
          '<span style="color:' +
          "#000" +
          "; font-weight:" +
          "bold" +
          "; font-size: " +
          "2rem" +
          "; text-align:" +
          "center" +
          '; height: 36">' +
          this.state.trainingContractorCount.map(
            (data) => data.training_contractor_count,
          ) +
          "</span>",
        verticalAlign: "middle",
      },
      yAxis: {
        title: {
          enabled: false,
        },
      },
      plotOptions: {
        pie: {
          shadow: false,
          borderWidth: 0,
          dataLabels: {
            enabled: false,
          },
        },
      },
      colors: this.state.trainingContractorCount.map((data) => data.color),
      series: [
        {
          data: [
            this.state.trainingContractorCount.map(
              (data) => data.training_contractor_count,
            ),
          ],
          size: "100%",
          innerSize: "84%",
        },
      ],
    };

    if (this.state.originFlag == "thgD") {
      var originUrl = {
        pathname: `/`,
      };
    } else if (this.state.originFlag == "thgPO") {
      var originUrl = {
        pathname: `/ua-uc/open`,
      };
    } else if (this.state.originFlag == "thgPR") {
      var originUrl = {
        pathname: `/ua-uc/resolve`,
      };
    }

    if (this.state.dataLoading) {
      return (
        <div className="my-3">
          {" "}
          <ClideLoader />
        </div>
      );
    }
    const hTriangleChart = {
      chart: {
        type: "pyramid",
      },
      colors: ["#206EB6", "#45B5F4", "#DBFF00", "#FF9900", "#FF0000"],
      credits: {
        enabled: false,
      },
      title: {
        text: "H T Present",
        x: -50,
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: "<b>{point.name}</b> ({point.y:,.0f})",
            softConnector: true,
          },
          center: ["42%", "50%"],
          width: "60%",
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        pointFormat: "<b>{point.y}</b>",
        shared: true,
        backgroundColor: "#FFFFFF",
        borderColor: "#EBEBEB",
        borderRadius: 10,
      },
      series: [
        {
          data: [
            ["UA/UC", reportData.ua_number + reportData.uc_number],
            ["NM", reportData.nm_ua_number + reportData.nm_uc_number],
            ["Notable", reportData.activityAnalysis?.notable_number || 0],
            ["FIrst Aid", reportData.activityAnalysis?.first_aid_number],
            ["OI", reportData.activityAnalysis?.occupational_illness_number],
            ["LTI", reportData.lti_number],
            ["RTA", reportData.rta_number || 0],
            ["MTC", reportData.mtc_number],
            ["FA", reportData.fa_number],
          ],
        },
      ],
    };
    // this.FetchActivityDetails(reportData)
    console.log(
      "rrrrrrrrrrrrrr",
      this.state.activity_img,
      this.state.activitydata,
    );
    const { isToggled } = this.state;
    return (
      <div className="clide-v2-pe-5 clide-v2-ps-5 container-fluid mb-5 pe-5 ps-5">
        <DetailTimelineSection
          data={this.renderTimeLine(reportData, this.state)}
          // activity={this.FetchActivityDetails()}

          state={this.state}
          url={originUrl}
          functionContent={this}
          variableData={{ isApproveEnabled, isReportedUserEnabled }}
          reportingScreen={this.state.reportingScreen}
        />

        <div className="row mt-3">
          <div className="col-12 col-md-9 col-lg-9">
            <div className="clide-v2-card-box-1">
              <div id="workexperience" className="sectionClass pt-1">
                <div className="row ">
                  <div className="fullWidth eight columns">
                    <ul className="cbp_tmtimeline">
                      <li>
                        <div className="cbp_tmicon cbp_tmicon-phone">
                          <TimelineDocIcon />
                        </div>
                        <div className="cbp_tmlabel clide-v2-white-box">
                          <div className="row">
                            {this.state.reportDetail
                              ?.observationAnalysisData ? null : (
                              <div className="col-12 col-md-4 col-lg-4">
                                <CarouselComponent
                                  items={this.__generateCarouselData(
                                    this.state.reportDetail.evidence,
                                  )}
                                  showArrows={false}
                                />
                              </div>
                            )}
                            <div className="col-12 col-md-12 col-lg-12">
                              <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold text-center pt-3 w-space-nobreak">
                                {t("reportedDetail")}
                              </p>

                              {this.state.reportDetail
                                ?.observationAnalysisData ? (
                                <div style={{ fontSize: "15px" }}>
                                  <p
                                    className="text-muted"
                                    style={{ maxWidth: "800px" }}
                                  >
                                    This section shows the main details of the
                                    Unsafe Act or Unsafe Condition reported. It
                                    includes evidence (Image or Video if
                                    uploaded), a observation of what was
                                    observed, the type of hazard involved, the
                                    risk level (like low, medium, high or
                                    extreme), and the source of the hazard.
                                  </p>

                                  <div className="row">
                                    {this.state.previousDate && (
                                      <div className="col-md-12 mb-4">
                                        <h6 className="fw-semibold">
                                          Date of Occurrence :
                                        </h6>
                                        <div className="border rounded p-3 shadow-sm">
                                          {this.state.selectedDate}
                                        </div>
                                      </div>
                                    )}
                                    {/* Evidence */}
                                    <div className="col-md-6 mb-4">
                                      <h6 className="fw-semibold">
                                        Evidence :
                                      </h6>
                                      <div className="border rounded p-3 shadow-sm">
                                        <CarouselComponent
                                          items={this.__generateCarouselData(
                                            this.state.reportDetail.evidence,
                                          )}
                                          showArrows={false}
                                        />
                                      </div>

                                      <h6 className="mt-3 fw-semibold">
                                        Observation :
                                      </h6>
                                      <div className="border rounded p-3 shadow-sm bg-light">
                                        {reportData.observation != "" && (
                                          <div className="output-text">
                                            {reportData.observation}
                                          </div>
                                        )}{" "}
                                        {reportData.observation_recording !=
                                          undefined &&
                                          reportData.observation_recording.substr(
                                            reportData.observation_recording
                                              .length - 3,
                                          ) == "mp3" && (
                                            <AudioPlayer
                                              src={
                                                reportData.observation_recording
                                              }
                                              showJumpControls={true}
                                              layout="horizontal-reverse"
                                              customVolumeControls={[]}
                                              customAdditionalControls={[]}
                                              className="border-0  shadow-none"
                                            />
                                          )}
                                      </div>
                                    </div>

                                    {/* AI Evidence */}
                                    <div className="col-md-6 mb-4">
                                      <h6 className="fw-semibold">
                                        AI Analysed Evidence :
                                      </h6>
                                      <div className="border rounded p-3 shadow-sm position-relative">
                                        {/* <span className="badge bg-success position-absolute" style={{ top: "10px", right: "10px" }}>
                                        AI Verified
                                      </span> */}
                                        <CarouselComponent
                                          items={this.__generateCarouselData(
                                            this.state.reportDetail.evidence,
                                          )}
                                          showArrows={false}
                                        />
                                      </div>
                                      <span
                                        className="mt-3"
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "6px",
                                        }}
                                      >
                                        <h6
                                          className="fw-semibold"
                                          style={{ display: "inline-block" }}
                                        >
                                          Observation Analysis :
                                        </h6>{" "}
                                        {renderToolTip(
                                          this.state.observationTooltipText,
                                          "left",
                                          {
                                            width: "14px",
                                            marginTop: "-6px",
                                            marginBottom: "2px",
                                          },
                                          1,
                                          "Info",
                                          false,
                                        )}
                                      </span>
                                      <div className="border rounded p-3 shadow-sm bg-light">
                                        <p className="mb-0">
                                          {this.state.reportDetail?.observationAnalysisData?.Statements?.map(
                                            (item, index, arr) => {
                                              let style = {
                                                cursor: "pointer",
                                                fontWeight: "600",
                                              };

                                              if (
                                                item.Sentiment === "Positive"
                                              ) {
                                                style.color = "#1e8f41";
                                              } else if (
                                                item.Sentiment === "Neutral"
                                              ) {
                                                style.color = "#c49f00";
                                              } else if (
                                                item.Sentiment === "Negative"
                                              ) {
                                                style.color = "#d9534f";
                                              }

                                              let cleanedText =
                                                item.Statement.trim().replace(
                                                  /[.,;!]+$/g,
                                                  "",
                                                );

                                              return (
                                                <span
                                                  key={index}
                                                  style={style}
                                                  title={item.Sentiment}
                                                >
                                                  {cleanedText}.
                                                  {index !== arr.length - 1
                                                    ? " "
                                                    : ""}
                                                </span>
                                              );
                                            },
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="row">
                                  <div className="col-12 col-md-12 col-lg-12 mb-2">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("observation")} :
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.observation != "" && (
                                          <div className="output-text">
                                            {reportData.observation}
                                          </div>
                                        )}{" "}
                                        {reportData.observation_recording !=
                                          undefined &&
                                          reportData.observation_recording.substr(
                                            reportData.observation_recording
                                              .length - 3,
                                          ) == "mp3" && (
                                            <AudioPlayer
                                              src={
                                                reportData.observation_recording
                                              }
                                              showJumpControls={true}
                                              layout="horizontal-reverse"
                                              customVolumeControls={[]}
                                              customAdditionalControls={[]}
                                              className="border-0  shadow-none"
                                            />
                                          )}
                                      </label>
                                    </div>
                                  </div>
                                  {CheckFormSettingField(
                                    reportData.form_setting?.setting,
                                    "hazard",
                                  ) && reportData?.hazard ? (
                                    <div className="col-12 col-md-6 col-lg-6 mb-2">
                                      <div className="col-12 col-md-12 col-lg-12 px-0">
                                        <div className="clide-v2-title mb-1">
                                          <label className="clide-v2-fs-4 mb-0">
                                            {t("hazard")} :
                                          </label>
                                        </div>
                                      </div>
                                      <div className="clide-v2-title mb-1">
                                        <label className="">
                                          {reportData.hazard}
                                        </label>
                                      </div>
                                    </div>
                                  ) : null}
                                  <div className="col-12 col-md-6 col-lg-6 mb-2">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("riskLevel")} :
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title  mb-1">
                                      <label className="">
                                        <img
                                          src={badgeEnum[reportData.severity]}
                                          style={{
                                            width: "30px",
                                            height: "30px",
                                          }}
                                        />
                                        &nbsp; &nbsp;
                                        {reportData.severity}
                                      </label>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6 col-lg-6 mb-2">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("source")} :
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.source}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </li>
                      {this.state.reportDetail?.observationAnalysisData ? (
                        <li>
                          <div className="cbp_tmicon cbp_tmicon-screen">
                            <TimelineInfoIcon />
                          </div>
                          <div className="cbp_tmlabel clide-v2-white-box">
                            <div className="row">
                              <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-1">
                                {t("Risk Level")}
                              </p>
                              <div className="row">
                                <div className="col-12 col-md-12 col-lg-12">
                                  <div
                                    className="row mt-4"
                                    style={{ fontSize: "15px" }}
                                  >
                                    {/* Reported Table */}
                                    <div className="col-md-6 mb-4">
                                      <h6 className="fw-semibold">
                                        Reported :
                                      </h6>
                                      <table className="table table-bordered">
                                        <thead>
                                          <tr className="text-center">
                                            <th>Fields</th>
                                            <th>Reported</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr className="text-center">
                                            <td>Risk Level</td>
                                            <td>
                                              <label className="">
                                                <img
                                                  src={
                                                    badgeEnum[
                                                      reportData.severity
                                                    ]
                                                  }
                                                  style={{
                                                    width: "30px",
                                                    height: "30px",
                                                  }}
                                                />
                                                &nbsp; &nbsp;
                                                {reportData.severity}
                                              </label>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>

                                    {/* AI Analysed Table */}
                                    <div className="col-md-6 mb-4">
                                      <h6 className="fw-semibold">
                                        Risk Insight :
                                      </h6>
                                      <table className="table table-bordered">
                                        <thead>
                                          <tr className="text-center">
                                            <th>Fields</th>
                                            <th>Reported</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {/* Risk Level */}
                                          <tr className="text-center">
                                            <td>Risk Level</td>
                                            <td>
                                              <label className="">
                                                <img
                                                  src={
                                                    badgeEnum[
                                                      this.state.reportDetail
                                                        ?.observationAnalysisData
                                                        ?.OverallRisk
                                                        ?.OverallRiskLevel
                                                    ]
                                                  }
                                                  style={{
                                                    width: "30px",
                                                    height: "30px",
                                                  }}
                                                />
                                                &nbsp; &nbsp;
                                                {
                                                  this.state.reportDetail
                                                    ?.observationAnalysisData
                                                    ?.OverallRisk
                                                    ?.OverallRiskLevel
                                                }
                                              </label>
                                            </td>
                                          </tr>

                                          {/* Risk Percentage */}
                                          <tr className="text-center">
                                            <td>Risk Percentage</td>
                                            <td>
                                              {this.state.reportDetail
                                                ?.observationAnalysisData
                                                ?.OverallRisk
                                                ?.AverageRiskPercentage ||
                                                0}{" "}
                                              %
                                            </td>
                                          </tr>

                                          {/* Sentiment Analysis */}
                                          <tr className="text-center">
                                            <td>Sentiment Analysis</td>
                                            <td>
                                              {(() => {
                                                const sentiment =
                                                  this.state.reportDetail
                                                    ?.observationAnalysisData?.[
                                                    "Status of Complete summery"
                                                  ] || "Neutral";
                                                let color = "#c49f00"; // neutral default

                                                if (sentiment === "Positive")
                                                  color = "#1e8f41";
                                                else if (
                                                  sentiment === "Negative"
                                                )
                                                  color = "#d9534f";

                                                return (
                                                  <span
                                                    style={{
                                                      color,
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    {sentiment}
                                                  </span>
                                                );
                                              })()}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      ) : null}

                      {this?.state?.resolveFlag == "resolve" ? (
                        <li>
                          <div className="cbp_tmicon cbp_tmicon-screen">
                            <TimelineInfoIcon />
                          </div>
                          <div className="cbp_tmlabel clide-v2-white-box">
                            <div className="row">
                              <div className="col-12  mb-2">
                                <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-4">
                                  {t("resolvedDetails")}
                                </p>
                                {this.state.reportDetail.closingDetails &&
                                  this.state.reportDetail.closingDetails.map(
                                    (data, index) => (
                                      <div
                                        className="row mb-2"
                                        style={{
                                          borderRadius: 5,
                                          backgroundColor: "whitesmoke",
                                          padding: "15px 0",
                                        }}
                                      >
                                        <div className="col-12 col-md-6 col-lg-6">
                                          <div className="col-12 col-md-12 col-lg-12 px-0">
                                            <div className="clide-v2-title mb-1">
                                              <label className="clide-v2-fs-4 mb-0">
                                                {t("resolvedEvidence") +
                                                  ` ${this.state.reportDetail.closingDetails.length > 1 ? index + 1 : ""}`}
                                              </label>
                                            </div>
                                          </div>
                                          <div className="clide-v2-title mb-1">
                                            <label className="">
                                              {data.resolveEvidence &&
                                              data.resolveEvidence.length ==
                                                0 ? (
                                                <div>
                                                  <img
                                                    src={img}
                                                    className="img-fluid"
                                                  />
                                                </div>
                                              ) : (
                                                <CarouselComponent
                                                  items={this.__generateCarouselData(
                                                    data.resolveEvidence,
                                                  )}
                                                  showArrows={false}
                                                />
                                              )}
                                            </label>
                                          </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-6">
                                          <div className="col-12 col-md-12 col-lg-12 px-0">
                                            <div className="clide-v2-title mb-1">
                                              <label className="clide-v2-fs-4 mb-0">
                                                {t("resolvedRemark") +
                                                  ` ${this.state.reportDetail.closingDetails.length > 1 ? index + 1 : ""}`}
                                              </label>
                                            </div>
                                          </div>
                                          <div className="clide-v2-title mb-1">
                                            <label className="">
                                              <div>
                                                <div className="feild-group rd-box ">
                                                  {data.closingRemarks && (
                                                    <div className="output-text">
                                                      {data.closingRemarks}
                                                    </div>
                                                  )}
                                                </div>

                                                <div className="feild-group rd-box">
                                                  {reportData.closing_remark_recording !=
                                                    undefined &&
                                                    reportData.closing_remark_recording.substr(
                                                      reportData
                                                        .closing_remark_recording
                                                        .length - 3,
                                                    ) == "mp3" && (
                                                      <AudioPlayer
                                                        src={
                                                          reportData.closing_remark_recording
                                                        }
                                                        showJumpControls={true}
                                                        layout="horizontal-reverse"
                                                        customVolumeControls={[]}
                                                        customAdditionalControls={[]}
                                                      />
                                                    )}
                                                </div>
                                              </div>
                                            </label>
                                          </div>
                                          {/* <div className="col-12 col-md-6 col-lg-6"> */}
                                          <div className="col-12 col-md-12 col-lg-12 px-0">
                                            <div className="clide-v2-title mb-1">
                                              <label className="clide-v2-fs-4 mb-0">
                                                {t("resolvedDate") +
                                                  ` ${this.state.reportDetail.closingDetails.length > 1 ? index + 1 : ""}`}
                                              </label>
                                            </div>
                                          </div>
                                          <div className="clide-v2-title mb-1">
                                            <label className="">
                                              {data.createdAt
                                                ? moment(data.createdAt).format(
                                                    "DD-MM-YYYY",
                                                  )
                                                : "N/A"}
                                            </label>
                                          </div>
                                          {/* </div> */}
                                        </div>
                                        {data?.postReviewerRemark && (
                                          <>
                                            <div className="col-12 col-md-6 col-lg-6">
                                              <div className="col-12 col-md-12 col-lg-12 px-0">
                                                <div className="clide-v2-title mb-1">
                                                  <label className="clide-v2-fs-4 mb-0">
                                                    Remark Type
                                                  </label>
                                                </div>
                                              </div>
                                              <div className="clide-v2-title mb-1">
                                                <label className="">
                                                  {
                                                    data?.postReviewerRemark
                                                      ?.remarkType
                                                  }
                                                </label>
                                              </div>
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-6">
                                              <div className="col-12 col-md-12 col-lg-12 px-0">
                                                <div className="clide-v2-title mb-1">
                                                  <label className="clide-v2-fs-4 mb-0">
                                                    Date
                                                  </label>
                                                </div>
                                              </div>
                                              <div className="clide-v2-title mb-1">
                                                <label className="">
                                                  {moment(
                                                    data?.postReviewerRemark
                                                      ?.createdAt,
                                                  ).format("DD/MM/YYYY HH:mm")}
                                                </label>
                                              </div>
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-6">
                                              <div className="col-12 col-md-12 col-lg-12 px-0">
                                                <div className="clide-v2-title mb-1">
                                                  <label className="clide-v2-fs-4 mb-0">
                                                    Remark
                                                  </label>
                                                </div>
                                              </div>
                                              <div className="clide-v2-title mb-1">
                                                <label className="">
                                                  {
                                                    data?.postReviewerRemark
                                                      ?.remark
                                                  }
                                                </label>
                                              </div>
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-6">
                                              <div className="col-12 col-md-12 col-lg-12 px-0">
                                                <div className="clide-v2-title mb-1">
                                                  <label className="clide-v2-fs-4 mb-0">
                                                    Category
                                                  </label>
                                                </div>
                                              </div>
                                              <div className="clide-v2-title mb-1">
                                                <label className="">
                                                  {
                                                    data?.postReviewerRemark
                                                      ?.uaUcCategoryName
                                                  }
                                                </label>
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    ),
                                  )}
                              </div>
                            </div>
                          </div>
                        </li>
                      ) : null}
                      <li>
                        <div className="cbp_tmicon cbp_tmicon-screen">
                          <TimelineInfoIcon />
                        </div>
                        <div className="cbp_tmlabel clide-v2-white-box">
                          <div className="row">
                            <div className="col-12 col-md-6 col-lg-6 mb-2">
                              <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-4">
                                {t("activityInfo")}
                              </p>
                              <div className="row">
                                {reportData?.companyName && (
                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          Company
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData?.companyName}
                                      </label>
                                    </div>
                                  </div>
                                )}

                                <div className="col-12 col-md-6 col-lg-6">
                                  <div className="col-12 col-md-12 col-lg-12 px-0">
                                    <div className="clide-v2-title mb-1">
                                      <label className="clide-v2-fs-4 mb-0">
                                        {t("service")}{" "}
                                      </label>
                                    </div>
                                  </div>
                                  <div className="clide-v2-title mb-1">
                                    <label className="">
                                      {reportData.service_name}
                                    </label>
                                  </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6">
                                  <div className="col-12 col-md-12 col-lg-12 px-0">
                                    <div className="clide-v2-title mb-1">
                                      <label className="clide-v2-fs-4 mb-0">
                                        {t("plantProject")}{" "}
                                      </label>
                                    </div>
                                  </div>
                                  <div className="clide-v2-title mb-1">
                                    <label className="">
                                      {reportData.project_name}
                                    </label>
                                  </div>
                                </div>
                                {CheckFormSettingField(
                                  reportData.form_setting?.setting,
                                  "barrier",
                                ) ? (
                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("barrier")}{" "}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.barrier}
                                      </label>
                                    </div>
                                  </div>
                                ) : null}

                                {reportData.project_category_name ? (
                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("projectCategory")}{" "}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.project_category_name}
                                      </label>
                                    </div>
                                  </div>
                                ) : null}

                                {reportData.activity ? (
                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("activity")}{" "}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.activity}
                                      </label>
                                    </div>
                                  </div>
                                ) : null}

                                {reportData.sub_activity ? (
                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("Sub Activity")}{" "}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.sub_activity}
                                      </label>
                                    </div>
                                  </div>
                                ) : null}

                                {CheckFormSettingField(
                                  reportData.form_setting?.setting,
                                  "Hazard",
                                ) && reportData.hazard ? (
                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("Hazard")}{" "}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.hazard}
                                      </label>
                                    </div>
                                  </div>
                                ) : null}

                                {CheckFormSettingField(
                                  reportData.form_setting?.setting,
                                  "Sub Hazard",
                                ) && reportData.subHazard ? (
                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("subHazard")}{" "}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.subHazard}
                                      </label>
                                    </div>
                                  </div>
                                ) : null}

                                {/* {reportData.project_category_name ? (
                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("projectCategory")}{" "}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.project_category_name}
                                      </label>
                                    </div>
                                  </div>
                                ) : null} */}

                                {reportData.region ? (
                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("region")}{" "}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.region}
                                      </label>
                                    </div>
                                  </div>
                                ) : null}

                                {reportData.state ? (
                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("state")}{" "}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.state}
                                      </label>
                                    </div>
                                  </div>
                                ) : null}

                                {reportData.city ? (
                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("city")}{" "}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.city}
                                      </label>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-6 mb-2">
                              <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-4">
                                {this.state.userData?.div_dept == 1
                                  ? t("depContract")
                                  : t("depContractWoDiv")}
                              </p>
                              <div className="row">
                                {this.state.userData?.div_dept == 1 &&
                                reportData.division ? (
                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("division")}{" "}
                                          <BarChart2
                                            className="cursor-p ml-2"
                                            title="Show Counts"
                                            onClick={() =>
                                              this.onViewCountDetails(
                                                "Division",
                                              )
                                            }
                                          />
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.division}
                                      </label>
                                    </div>
                                  </div>
                                ) : null}
                                <div className="col-12 col-md-6 col-lg-6">
                                  <div className="col-12 col-md-12 col-lg-12 px-0">
                                    <div className="clide-v2-title mb-1">
                                      <label className="clide-v2-fs-4 mb-0">
                                        {t("department")}{" "}
                                        <BarChart2
                                          className="cursor-p ml-2"
                                          title="Show Counts"
                                          onClick={() =>
                                            this.onViewCountDetails(
                                              "Department",
                                            )
                                          }
                                        />
                                      </label>
                                    </div>
                                  </div>
                                  {!reportData.department ? (
                                    <div className="clide-v2-title mb-1">
                                      <label className="">{t("na")}</label>
                                    </div>
                                  ) : (
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.department}
                                      </label>
                                    </div>
                                  )}
                                </div>

                                {CheckFormSettingField(
                                  reportData.form_setting?.setting,
                                  "zone",
                                ) ? (
                                  <div className="col-12 col-md-6 col-lg-6">
                                    {this.state.showZone && reportData.zone && (
                                      <>
                                        <div className="col-12 col-md-12 col-lg-12 px-0">
                                          <div className="clide-v2-title mb-1">
                                            <label className="clide-v2-fs-4 mb-0">
                                              {t("zone")}{" "}
                                              <BarChart2
                                                className="cursor-p ml-2"
                                                title="Show Counts"
                                                onClick={() =>
                                                  this.onViewCountDetails(
                                                    "Zone",
                                                  )
                                                }
                                              />
                                            </label>
                                          </div>
                                        </div>
                                        <div className="clide-v2-title mb-1">
                                          <label className="">
                                            {reportData.zone}
                                          </label>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                ) : null}
                                {CheckFormSettingField(
                                  reportData.form_setting?.setting,
                                  "location",
                                ) ? (
                                  <div className="col-12 col-md-12 col-lg-6">
                                    {this.state.showLocation &&
                                      reportData.location && (
                                        <>
                                          <div className="col-12 col-md-12 col-lg-12 px-0">
                                            <div className="clide-v2-title mb-1">
                                              <label className="clide-v2-fs-4 mb-0">
                                                {t("location")}{" "}
                                                <BarChart2
                                                  className="cursor-p ml-2"
                                                  title="Show Counts"
                                                  onClick={() =>
                                                    this.onViewCountDetails(
                                                      "Location",
                                                    )
                                                  }
                                                />
                                              </label>
                                            </div>
                                          </div>
                                          <div className="clide-v2-title mb-1">
                                            <label className="">
                                              {reportData.location}
                                            </label>
                                          </div>
                                        </>
                                      )}
                                  </div>
                                ) : null}

                                {CheckFormSettingField(
                                  reportData.form_setting?.setting,
                                  "contractor",
                                ) &&
                                this.state.showContractor &&
                                reportData.contractor ? (
                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4 mb-0">
                                          {t("contract")}{" "}
                                          <BarChart2
                                            className="cursor-p ml-2"
                                            title="Show Counts"
                                            onClick={() =>
                                              this.onViewCountDetails(
                                                "Contractor",
                                              )
                                            }
                                          />
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {reportData.contractor}
                                      </label>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      {((CheckFormSettingField(
                        reportData.form_setting?.setting,
                        "control measure",
                      ) ||
                        CheckFormSettingField(
                          reportData.form_setting?.setting,
                          "existing control measure",
                        ) ||
                        CheckFormSettingField(
                          reportData.form_setting?.setting,
                          "recommended control measure",
                        )) &&
                        reportData.control_measure) ||
                      this.state.controlMeasureList.length > 0 ? (
                        <li>
                          <div className="cbp_tmicon cbp_tmicon-screen">
                            <TimelineInfoIcon />
                          </div>
                          <div className="cbp_tmlabel clide-v2-white-box">
                            <div className="row">
                              <div className="col-12 col-md-6 col-lg-6 mb-2">
                                <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-4">
                                  {t("controlMeasure")}
                                </p>
                                <div className="row">
                                  {reportData.control_measure_recording !=
                                    undefined &&
                                    reportData.control_measure_recording.substr(
                                      reportData.control_measure_recording
                                        .length - 3,
                                    ) == "mp3" && (
                                      <div className="col-12 col-md-6 col-lg-6">
                                        <div className="col-12 col-md-12 col-lg-12 px-0">
                                          <div className="clide-v2-title mb-1">
                                            <AudioPlayer
                                              src={
                                                reportData.control_measure_recording
                                              }
                                              showJumpControls={true}
                                              layout="horizontal-reverse"
                                              customVolumeControls={[]}
                                              customAdditionalControls={[]}
                                              className="border-0  shadow-none"
                                            />
                                          </div>
                                        </div>
                                        <div className="clide-v2-title mb-1">
                                          <label className="">
                                            {reportData.service_name}
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  {reportData.control_measure && (
                                    <div className="col-12 col-md-6 col-lg-6">
                                      <div className="clide-v2-title mb-1">
                                        <label className="">
                                          {reportData.control_measure}
                                        </label>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.controlMeasureList.some(
                                    (d) => d.type,
                                  ) ? (
                                    <>
                                      <div className="col-12 col-md-6 col-lg-6">
                                        <div className="clide-v2-title mb-1">
                                          <label className="clide-v2-fs-4 mb-0 fw-bold">
                                            {t("existingControlMeasure")}
                                          </label>
                                        </div>
                                        {this.state.controlMeasureList
                                          .filter((d) => d.type === "EXISTING")
                                          .map((data, index) => (
                                            <div
                                              key={`existing-cm-${data.id}`}
                                              className="output-text common-card-border-layout-4  px-3 py-2 font-18 shadow-none my-3 "
                                            >
                                              {`${index + 1}. ${data.controlMeasure}`}
                                            </div>
                                          ))}
                                      </div>
                                      <div className="col-12 col-md-6 col-lg-6">
                                        <div className="clide-v2-title mb-1">
                                          <label className="clide-v2-fs-4 mb-0 fw-bold">
                                            {t("recommendedControlMeasure")}
                                          </label>
                                        </div>
                                        {this.state.controlMeasureList
                                          .filter(
                                            (d) => d.type === "RECOMMENDED",
                                          )
                                          .map((data, index) => (
                                            <div
                                              key={`recommended-cm-${data.id}`}
                                              className="output-text common-card-border-layout-4  px-3 py-2 font-18 shadow-none my-3 "
                                            >
                                              {`${index + 1}. ${data.controlMeasure}`}
                                            </div>
                                          ))}
                                      </div>
                                    </>
                                  ) : (
                                    <div className="col-12 col-md-6 col-lg-6">
                                      <div className="clide-v2-title mb-1">
                                        {this.state.controlMeasureList.map(
                                          (data, index) => (
                                            <div
                                              key={`cm-${index}`}
                                              className="output-text common-card-border-layout-4  px-3 py-2 font-18 shadow-none my-3 "
                                            >
                                              {`${index + 1}. ${
                                                data.controlMeasure
                                              }`}
                                            </div>
                                          ),
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      ) : null}

                      <li>
                        <div className="cbp_tmicon cbp_tmicon-screen">
                          <TimelineInfoIcon />
                        </div>
                        <div className="cbp_tmlabel clide-v2-white-box">
                          <div className="row">
                            <div className="col-12 col-lg-4 col-md-4 mb-2">
                              <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-4">
                                {t("assignedDetails")}
                              </p>
                              <div className="row">
                                <div className="col-12 ">
                                  <div className="col-12 col-md-12 col-lg-12 px-0">
                                    <div className="clide-v2-title mb-1">
                                      <label className="clide-v2-fs-4">
                                        {t("assignedTo")}
                                      </label>
                                    </div>
                                  </div>
                                  <div className="border py-2 rounded text-center">
                                    <div className="clide-v2-fs-4 font-weight-bold">
                                      <label className="">
                                        {reportData.assigned_user}
                                      </label>
                                    </div>
                                    <GetPopoverFrame
                                      element={
                                        <>
                                          <img
                                            src={reportData.assigned_user_pic}
                                            alt=""
                                            className="clide-v2-profile-img"
                                          />
                                        </>
                                      }
                                      mappingKeys={() => {
                                        const detail =
                                          getUserProfileDetails(
                                            [null, undefined, 0].includes(
                                              this.state.reportDetail
                                                ?.assigned_user_id,
                                            )
                                              ? this.state.userData?.user_id
                                              : this.state.reportDetail
                                                  ?.assigned_user_id,
                                            this.state.userLists,
                                          ) ?? {};
                                        return {
                                          [t("id")]:
                                            detail["employeeId"] ?? "NA",
                                          [t("department")]:
                                            detail["field"]?.split(":")[1] ??
                                            "NA",
                                          [t("type")]:
                                            detail["userType"] ?? "NA",
                                          [t("designation")]:
                                            detail["designation"] ?? "NA",
                                          [t("contact")]:
                                            detail["contact_number"] ?? "NA",
                                          // Zone: detail['designation'],
                                          // Location: detail['designation'],
                                        };
                                      }}
                                      viewProps={{
                                        top: "-6px",
                                        right: "20%",
                                        marginLeft: "127px",
                                      }}
                                    />
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className=" mb-0">
                                          {t("riskdueDate")}{" "}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="clide-v2-title mb-1">
                                      <label className="">
                                        {convertDateFromTimezone(
                                          reportData.target_date,
                                        ) ||
                                          reportData.riskBaseDueDate ||
                                          "17/05/2000"}
                                        {/* {convertDateFromTimezone("2025-05-14T05:27:08.000+00:00") || reportData.riskBaseDueDate || "17/05/2000"} */}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-md-8 col-lg-8 mb-2">
                              <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-4">
                                {t("invitedTeam")} (
                                {reportData.invited_user?.length})
                              </p>
                              <div className="row">
                                <div className="col-12 mt-4 pt-1">
                                  <div className="col-12 col-md-12 col-lg-12 px-0"></div>
                                  <Scrollbars
                                    style={{ height: "11rem" }}
                                    renderView={(props) => (
                                      <div
                                        {...props}
                                        style={{
                                          paddingRight: "15px",
                                          ...props.style,
                                          overflowX: "hidden",
                                        }}
                                      />
                                    )}
                                  >
                                    <div className="col-12 d-flex">
                                      {reportData.invited_user?.map(
                                        (image, index) => (
                                          <div
                                            className="feild-group  px-2 py-2 mr-2 rounded-0 shadow-none text-center  "
                                            style={{
                                              minWidth: "11rem",
                                            }}
                                            key={index}
                                          >
                                            <div className="border rounded h-100">
                                              <span className=" fs-6  font-weight-bold">
                                                {image.username}
                                              </span>
                                              <div
                                                className="image-box my-3"
                                                style={{
                                                  marginRight: "0.5rem",
                                                }}
                                              >
                                                <GetPopoverFrame
                                                  element={
                                                    <>
                                                      <img
                                                        src={image.userpic}
                                                        alt=""
                                                        className="clide-v2-profile-img"
                                                      />
                                                    </>
                                                  }
                                                  mappingKeys={() => {
                                                    const detail =
                                                      getUserProfileDetails(
                                                        image.userid,
                                                        this.state.userLists,
                                                      ) ?? {};
                                                    return {
                                                      [t("id")]:
                                                        detail["employeeId"] ??
                                                        "NA",
                                                      [t("department")]:
                                                        detail["field"]?.split(
                                                          ":",
                                                        )[1] ?? "NA",
                                                      [t("type")]:
                                                        detail["userType"] ??
                                                        "NA",
                                                      [t("designation")]:
                                                        detail["designation"] ??
                                                        "NA",
                                                      [t("contact")]:
                                                        detail[
                                                          "contact_number"
                                                        ] ?? "NA",
                                                    };
                                                  }}
                                                  viewProps={{
                                                    top: "-6px",
                                                    right: "10%",
                                                    marginLeft: "127px",
                                                  }}
                                                />
                                              </div>

                                              <div className="col-12 col-md-12 col-lg-12 px-0">
                                                {/* <div className="col-12 col-md-12 col-lg-12 px-0">
                                                    <div className="clide-v2-title mb-1">
                                                      <label className="clide-v2-fs-4 mb-0">
                                                      {convertDateFromTimezoneIST(
                                                    image.invite_date
                                                  ) || "NA"}
                                                      </label>
                                                    </div>
                                                  </div> */}
                                                <div className="clide-v2-title mb-1">
                                                  <label className="">
                                                    {convertDateFromTimezoneIST(
                                                      image.invite_date,
                                                    ) || "NA"}
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ),
                                      )}
                                    </div>
                                  </Scrollbars>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      {reportData.incident_person_details.length > 0 ? (
                        <li>
                          <div className="cbp_tmicon cbp_tmicon-screen">
                            <TimelineInfoIcon />
                          </div>
                          <div className="cbp_tmlabel clide-v2-white-box">
                            <div className="row">
                              <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-4">
                                {t("involvedPersonDetails")}
                              </p>
                              <div className="col-12 mb-2">
                                <div className="row">
                                  <div className="col-12 ">
                                    <Scrollbars
                                      style={{ height: "11rem" }}
                                      renderView={(props) => (
                                        <div
                                          {...props}
                                          style={{
                                            paddingRight: "15px",
                                            ...props.style,
                                            overflowX: "hidden",
                                          }}
                                        />
                                      )}
                                    >
                                      <div className="col-12 d-flex">
                                        {reportData.incident_person_details?.map(
                                          (data, index, arr) => {
                                            const detail =
                                              getUserProfileDetails(
                                                parseInt(
                                                  data.searched_incident_person_id,
                                                ),
                                                this.state.userLists,
                                              ) ?? {};
                                            const isUserFromOrgnization =
                                              data?.searched_incident_person_id;
                                            const position =
                                              arr.length - 1 === index
                                                ? "left"
                                                : "right";
                                            return isUserFromOrgnization ? (
                                              <div
                                                className="feild-group  px-2 py-2 mr-2 rounded-0 shadow-none text-center  "
                                                style={{
                                                  minWidth: "12rem",
                                                }}
                                              >
                                                <div className="border rounded">
                                                  <span className=" fs-6  font-weight-bold">
                                                    {data.incident_person_name}
                                                  </span>
                                                  <div
                                                    className="image-box my-3 "
                                                    style={{
                                                      marginRight: "0.5rem",
                                                    }}
                                                  >
                                                    <GetPopoverFrame
                                                      element={
                                                        <>
                                                          <img
                                                            src={
                                                              detail?.user_pic
                                                            }
                                                            alt=""
                                                            className="clide-v2-profile-img"
                                                          />
                                                        </>
                                                      }
                                                      mappingKeys={() => {
                                                        return {
                                                          ID:
                                                            detail[
                                                              "employeeId"
                                                            ] ?? "NA",
                                                          Department:
                                                            detail[
                                                              "field"
                                                            ]?.split(":")[1] ??
                                                            "NA",
                                                          Type:
                                                            detail[
                                                              "userType"
                                                            ] ?? "NA",
                                                          Designation:
                                                            detail[
                                                              "designation"
                                                            ] ?? "NA",
                                                          Contact:
                                                            detail[
                                                              "contact_number"
                                                            ] ?? "NA",
                                                          // Zone: detail['designation'],
                                                          // Location: detail['designation'],
                                                        };
                                                      }}
                                                      viewProps={{
                                                        top: "-6px",
                                                        right: "10%",
                                                        marginLeft: "127px",
                                                      }}
                                                    />
                                                  </div>
                                                  <div className="col-12 col-md-12 col-lg-12 px-0">
                                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                                      <div className="clide-v2-title mb-1">
                                                        <label className="clide-v2-fs-4 mb-0">
                                                          {t("id")}{" "}
                                                        </label>
                                                      </div>
                                                    </div>
                                                    <div className="clide-v2-title mb-1">
                                                      <label className="">
                                                        {data?.searched_incident_person_id
                                                          ? detail?.employeeId ||
                                                            data?.incident_person_id
                                                          : (detail.userId ??
                                                            index + 1)}
                                                      </label>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : (
                                              <>
                                                <div
                                                  className="feild-group  px-2 py-2 mr-2 rounded-0 shadow-none text-center  "
                                                  style={{
                                                    minWidth: "12rem",
                                                  }}
                                                >
                                                  <>
                                                    <div className="border rounded">
                                                      <span className=" fs-6  font-weight-bold">
                                                        {
                                                          data.incident_person_name
                                                        }
                                                      </span>

                                                      <div className="clide-v2-title mt-3 mb-2">
                                                        <label className="clide-v2-profile-img">
                                                          <img
                                                            src={require("../../../../assets/sls-icons/V2. New Development/user.svg")}
                                                            alt=""
                                                          />
                                                        </label>
                                                      </div>
                                                      <div className="col-12 col-md-12 col-lg-12 px-0">
                                                        <>
                                                          <div className="col-12 col-md-12 col-lg-12 px-0">
                                                            <div className="clide-v2-title mb-1">
                                                              <label className="clide-v2-fs-4 mb-0">
                                                                {t("id")}{" "}
                                                              </label>
                                                            </div>
                                                          </div>
                                                          <div className="clide-v2-title mb-1">
                                                            <label className="">
                                                              {data.incident_person_id ??
                                                                index + 1}
                                                            </label>
                                                          </div>
                                                        </>
                                                      </div>
                                                    </div>
                                                  </>
                                                </div>
                                              </>
                                            );
                                          },
                                        )}
                                      </div>
                                    </Scrollbars>
                                  </div>
                                  {/* <div className="col-12 col-md-6 col-lg-6 mb-2">
                      <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-4">
                        Department/Contractor/Location
                      </p>
                      <div className="row">
                        {CheckFormSettingField(
                          reportData.form_setting?.setting,
                          "department"
                        ) ? (
                          <div className="col-12 col-md-6 col-lg-6">
                            <div className="col-12 col-md-12 col-lg-12 px-0">
                              <div className="clide-v2-title mb-1">
                                <label className="clide-v2-fs-4 mb-0">
                                  Department{" "}
                                </label>
                              </div>
                            </div>
                            {!reportData.department?(<div className="clide-v2-title mb-1">
                              <label className="">
                              NA
                              </label>
                            </div>):(<div className="clide-v2-title mb-1">
                              <label className="">
                              {reportData.department}
                              </label>
                            </div>)}
                          </div>
                        ) : null}

                        {CheckFormSettingField(
                        reportData.form_setting?.setting,
                          "contractor"
                        ) &&
                        this.state.showContractor &&
                                    reportData.contractor ? (
                          <div className="col-12 col-md-6 col-lg-6">
                            <div className="col-12 col-md-12 col-lg-12 px-0">
                              <div className="clide-v2-title mb-1">
                                <label className="clide-v2-fs-4 mb-0">
                                  Contractor{" "}
                                </label>
                              </div>
                            </div>
                            <div className="clide-v2-title mb-1">
                              <label className="">
                              {reportData.contractor}
                              </label>
                            </div>
                          </div>
                        ) : null}

                        {CheckFormSettingField( reportData.form_setting?.setting, "zone")  ? (
                          <div className="col-12 col-md-6 col-lg-6">
                            {this.state.showZone &&
                                        reportData.zone && (
                              <>
                                <div className="col-12 col-md-12 col-lg-12 px-0">
                                  <div className="clide-v2-title mb-1">
                                    <label className="clide-v2-fs-4 mb-0">
                                      Zone{" "}
                                    </label>
                                  </div>
                                </div>
                                <div className="clide-v2-title mb-1">
                                  <label className="">
                                  {reportData.zone}
                                  </label>
                                </div>
                              </>
                            )}
                          </div>
                        ) : null}
                        {CheckFormSettingField(
                          reportData.form_setting?.setting,
                          "location"
                        )  ? (
                          <div className="col-12 col-md-12 col-lg-12 px-0">
                            {this.state.showLocation &&
                                        reportData.location && (
                              <>
                                <div className="col-12 col-md-12 col-lg-12 px-0">
                                  <div className="clide-v2-title mb-1">
                                    <label className="clide-v2-fs-4 mb-0">
                                      Location{" "}
                                    </label>
                                  </div>
                                </div>
                                <div className="clide-v2-title mb-1">
                                  <label className="">
                                  {reportData.location}
                                  </label>
                                </div>
                              </>
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      ) : null}
                      {CheckFormSettingField(
                        reportData.form_setting?.setting,
                        "Document",
                      ) && (
                        <li>
                          <div className="cbp_tmicon cbp_tmicon-screen">
                            <TimelineInfoIcon />
                          </div>
                          <div className="cbp_tmlabel clide-v2-white-box">
                            <DocumentComponent
                              t={t}
                              id={this.state.soiId}
                              editFlag={this.state.reportDetail?.edit_flag}
                              module={UAUC}
                            />
                          </div>
                        </li>
                      )}

                      {this.state.escalatedList.length > 0 ? (
                        <li>
                          <div className="cbp_tmicon cbp_tmicon-screen">
                            <TimelineInfoIcon />
                          </div>
                          <div className="cbp_tmlabel clide-v2-white-box">
                            <div className="row">
                              <div className="col-12  mb-2">
                                <div className="d-flex justify-content-between align-items-center">
                                  <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-4">
                                    {t("escalatedDetails")}
                                  </p>
                                  {this.state.isRiskBased && (
                                    <button
                                      className="clide-v2-btn-template clide-v2-secondary my-1 mb-1 px-3 justify-content-end"
                                      style={{
                                        marginTop: "-10px",
                                        borderColor: reportData.severity_color,
                                      }}
                                      // onClick={handleInputClick}
                                    >
                                      <span className="clide-v2-secondary-color">
                                        {t("riskLevel")} :{" "}
                                        <span
                                          style={{
                                            color: reportData.severity_color,
                                          }}
                                        >
                                          {reportData.severity}
                                        </span>
                                      </span>
                                    </button>
                                  )}
                                </div>
                                <div className="row">
                                  <div className="col-12 clide-v2-scroll-bar">
                                    <TreeUiComponent
                                      rootTitle={t("escalationMatrix")}
                                      nodes={this.__generateTreeNodes(
                                        this.state.escalatedList,
                                        reportData?.escalation_level_timeline,
                                      )}
                                      callback={this.__renderTreeTemplate}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      ) : null}
                      {(reportData.overdue != undefined &&
                        reportData?.overdue != 0) ||
                      (reportData.deviation != undefined &&
                        reportData?.deviation != 0) ? (
                        <li>
                          <div className="cbp_tmicon cbp_tmicon-screen">
                            <TimelineInfoIcon />
                          </div>
                          <div className="cbp_tmlabel clide-v2-white-box">
                            <div className="row">
                              <div className="col-12 col-md-6 col-lg-6 mb-2">
                                <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-4">
                                  {this.state.resolveFlag === "resolve"
                                    ? t("deviation")
                                    : t("overdue")}
                                </p>
                                <div className="row">
                                  <div className="col-12 ">
                                    <div className="col-12 col-md-12 col-lg-12 px-0">
                                      <div className="clide-v2-title mb-1">
                                        <label className="clide-v2-fs-4">
                                          {this.state.resolveFlag === "resolve"
                                            ? t("deviation")
                                            : t("overdue")}{" "}
                                          {t("by")}{" "}
                                        </label>
                                        <label className="clide-v2-fs-4 ml-3 border round p-2 rounded-5 px-5 clide-v2-active">
                                          {this.state.resolveFlag === "resolve"
                                            ? reportData.deviation
                                            : reportData.overdue}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      ) : null}

                      <DetailCommentSection
                        state={this.state}
                        functionContent={{ ...this, setState: this.setState }}
                      />
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3 col-lg-3">
            <div className="clide-v2-title mb-1 d-flex align-items-baseline">
              {this.state.uaucStatus === 1 && (
                <CommonDropdown
                  isRequired={false}
                  title={t("uaucStatus")}
                  optionList={filteredOptions}
                  onChangeHandle={this._typeactChangeHandle}
                  value={
                    this.state.selectedUaucStatus
                      ? this.state.selectedUaucStatus.id
                      : ""
                  }
                  disabled={
                    this.state.resolveFlag == "resolve" ||
                    this.state.reportingScreen == "archived"
                  }
                />
              )}
            </div>
            <div className="clide-v2-card-box-1 p-3">
              <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold text-center pt-3 w-space-nobreak">
                {t("reportedBy")}
              </p>
              <hr />
              <div className="d-flex p-1 mb-2 text-start">
                <div className="">
                  <OverlayTrigger
                    trigger="hover"
                    placement="left"
                    rootClose={true}
                    overlay={
                      <Popover
                        id="popover-positioned-bottom"
                        style={{ width: "15rem", borderRadius: "10px" }}
                      >
                        <Container>
                          <div className="my-3">
                            <span className="common-black-1 font-weight-500 font-16">
                              {t("reportedDt")} :
                            </span>
                            <span className="common-black-1 ml-3 font-16">
                              {convertDateFromTimezone(
                                reportData.submission_date,
                              )}
                            </span>
                          </div>
                          {/* <div className="my-3">
                            <span className="common-black-1 font-weight-500 font-16">
                              {t('reportedTime')} :
                            </span>
                            <span className="common-black-1 ml-3 font-16">
                              {reportData.submission_time}
                            </span>
                          </div> */}
                          <div className="my-3">
                            <span className="common-black-1 font-weight-500 font-16">
                              {t("reportedMonth")} :
                            </span>
                            <span className="common-black-1 ml-3 font-16">
                              {reportData.reportedmonth_name}
                            </span>
                          </div>
                        </Container>
                      </Popover>
                    }
                  >
                    <img
                      className="clide-v2-profile-img"
                      src={reportData.reported_by_pic}
                    />
                  </OverlayTrigger>
                </div>
                <div className="p-1 px-3 fw-bold w-100  ">
                  <div className="col-12 col-md-12 col-lg-12">
                    {reportData.reported_by}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-6 col-md-6 col-lg-6 mb-3">
                  <div className="">{t("id")} :</div>
                  <div className="clide-v2-title mb-1">
                    <label className="">
                      {" "}
                      {this.state.assignedDetails.emp_id}
                    </label>
                  </div>
                </div>
                <div className="col-6 col-md-6 col-lg-6 mb-3">
                  <div className="">{t("type")}</div>
                  <div className="clide-v2-title mb-1">
                    <label className="">
                      {this.state.assignedDetails.type ?? "NA"}
                    </label>
                  </div>
                </div>
                <div className="col-6 col-md-6 col-lg-6 mb-3">
                  <div className="">{t("department")}</div>
                  <div className="clide-v2-title mb-1">
                    <label className="">
                      {this.state.assignedDetails?.field?.split(":")[1] ?? "NA"}
                    </label>
                  </div>
                </div>
                <div className="col-6 col-md-6 col-lg-6 mb-3">
                  <div className="">{t("designation")}</div>
                  <div className="clide-v2-title mb-1">
                    <label className="">
                      {this.state.assignedDetails.designation ?? "NA"}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="clide-v2-card-box-1 mt-2 p-3">
              <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold text-center pt-3 w-space-nobreak">
                {t("badges")} ({this.state.likeNumber})
              </p>
              <hr />
              <div className="text-center clide-v2-border-primary-color border p-3 rounded">
                {this.state.userLike != "" ? (
                  this.state?.userLike?.map(
                    (item, index) =>
                      index < 5 && (
                        <React.Fragment>
                          <img
                            src={item.user_profile}
                            alt=""
                            data-tip
                            data-for={`user-name-${index}`}
                            className="clide-v2-profile-img"
                          />

                          <ReactTooltip
                            effect="solid"
                            place="right"
                            id={`user-name-${index}`}
                          >
                            <>
                              <span>{item.user_name}</span>
                            </>
                          </ReactTooltip>
                        </React.Fragment>
                      ),
                    // </div>
                  )
                ) : (
                  <p className="data-not-present mb-0">{t("badgesAvl")} </p>
                )}
              </div>
            </div>
            <div className="clide-v2-card-box-1 p-2 mt-2">
              <div className="d-flex align-items-center justify-content-center pt-3">
                <div>
                  <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold text-center pt-2 mr-4 w-space-nobreak">
                    {reportData?.activity} | {t("analysis")}
                  </p>
                </div>
                <div className="align-items-center">
                  <AdminSwitch
                    onChange={this.toggleState}
                    checked={isToggled}
                    handleDiameter={12}
                    offColor="#878787"
                    onColor="#F56620"
                    height={15}
                    width={25}
                    uncheckedIcon={
                      <div
                        className="s-admin-btn"
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          height: "100%",
                          fontSize: 15,
                          color: "white",
                          width: "100%",
                        }}
                      ></div>
                    }
                    checkedIcon={
                      <div
                        className="s-admin-btn"
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          height: "100%",
                          fontSize: 15,
                          color: "white",
                          width: "100%",
                        }}
                      ></div>
                    }
                  />
                </div>
              </div>
              <hr />
              {isToggled ? (
                <div className="clide-v2-white-box py-3 m-2">
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={hTriangleChart}
                  />
                </div>
              ) : (
                <div className=" p-3 mt-2">
                  {/* {reportData.fa_number == 0 &&
                    reportData.mtc_number == 0 &&
                    reportData.rta_number == 0 &&
                    reportData.lti_number == 0 ? (
                    <div className="graph-not-available-text">
                      {t('graphNA')}
                    </div>
                  ) : ( */}
                  <div className="col-12  mb-3">
                    <div className="clide-v2-white-box">
                      <div className="row align-items-center">
                        <div className="col-12 my-2">
                          <div className="sm-graph-modal-legend-text text-center mb-3">
                            <b>{t("iraAnalysis")}</b>
                          </div>

                          {config.isChartJsEnabled ? (
                            this.CountDoughnut(analysisChartData)
                          ) : (
                            <div style={{ width: "9rem" }}>
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={analysisChart}
                              />
                            </div>
                          )}
                        </div>
                        <div className="col-12 ">
                          <div className="outer-legend-block">
                            <Scrollbars
                              style={{
                                height: `6rem`,
                                margin: "0.5rem 0.2rem 0.5rem 0",
                              }}
                              renderView={(props) => (
                                <div
                                  style={{
                                    paddingRight: "15px",
                                    ...props.style,
                                    overflowX: "hidden",
                                  }}
                                />
                              )}
                            >
                              <div className="clide-v2-graph-left-box  d-flex align-items-center  ">
                                <span
                                  className="soi-kanban-modal-legend-box clide-v2-square-span "
                                  style={{ backgroundColor: "#FF4242" }}
                                ></span>
                                <span className="sm-graph-modal-legend-text ">
                                  {t("fa")}
                                </span>
                                <span className=" ml-auto">
                                  {reportData.fa_number}
                                </span>
                              </div>
                              <div className="soi-kanban-inner-legend-block  ">
                                <span
                                  className="soi-kanban-modal-legend-box clide-v2-square-span"
                                  style={{ backgroundColor: "#086992" }}
                                ></span>
                                <span className="sm-graph-modal-legend-text my-2">
                                  {t("mtc")}
                                </span>
                                <span className="legend-number float-end">
                                  {reportData.mtc_number}{" "}
                                </span>
                              </div>
                              <div className="soi-kanban-inner-legend-block  ">
                                <span
                                  className="soi-kanban-modal-legend-box clide-v2-square-span"
                                  style={{ backgroundColor: "#FAAC15" }}
                                ></span>
                                <span className="sm-graph-modal-legend-text my-2">
                                  {t("tra")}
                                </span>
                                <span className="legend-number float-end">
                                  {reportData.rta_number}
                                </span>
                              </div>
                              {/* /* // Britannia v01
                            //  Making this change to ...(Integrate this rta to tra and faid oi notable integration because of britian custoimization ) */}

                              <div className="soi-kanban-inner-legend-block  ">
                                <span
                                  className="soi-kanban-modal-legend-box clide-v2-square-span"
                                  style={{ backgroundColor: "#18DA07" }}
                                ></span>
                                <span className="sm-graph-modal-legend-text my-2">
                                  {t("lti")}
                                </span>
                                <span className="legend-number float-end">
                                  {reportData.lti_number}
                                </span>
                              </div>
                              <div className="soi-kanban-inner-legend-block  ">
                                <span
                                  className="soi-kanban-modal-legend-box clide-v2-square-span"
                                  style={{ backgroundColor: "#C511FF" }}
                                ></span>
                                <span className="sm-graph-modal-legend-text my-2">
                                  {t("oi")}
                                </span>
                                <span className="legend-number float-end">
                                  {
                                    reportData.activityAnalysis
                                      ?.occupational_illness_number
                                  }{" "}
                                </span>
                              </div>

                              <div className="soi-kanban-inner-legend-block  ">
                                <span
                                  className="soi-kanban-modal-legend-box clide-v2-square-span"
                                  style={{ backgroundColor: "#1589EE" }}
                                ></span>
                                <span className="sm-graph-modal-legend-text my-2">
                                  {t("firstAid")}
                                </span>
                                <span className="legend-number float-end">
                                  {
                                    reportData.activityAnalysis
                                      ?.first_aid_number
                                  }{" "}
                                </span>
                              </div>

                              <div className="soi-kanban-inner-legend-block  ">
                                <span
                                  className="soi-kanban-modal-legend-box clide-v2-square-span"
                                  style={{
                                    backgroundColor: "rgb(161, 255, 206)",
                                  }}
                                ></span>
                                <span className="sm-graph-modal-legend-text my-2">
                                  {t("notable")}
                                </span>
                                <span className="legend-number float-end">
                                  {
                                    reportData.activityAnalysis?.notable_number
                                  }{" "}
                                </span>
                              </div>
                            </Scrollbars>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* )} */}

                  {reportData.nm_ua_number == 0 &&
                  reportData.nm_uc_number == 0 ? (
                    <div className="graph-not-available-text">
                      {t("graphNA")}
                    </div>
                  ) : (
                    <div className="col-12  mb-3">
                      <div className="clide-v2-white-box">
                        <div className="row align-items-center">
                          <div className="col-12  my-2">
                            <div className="sm-graph-modal-legend-text text-center mb-3">
                              <b>{t("nmAnalysis")}</b>
                            </div>
                            {config.isChartJsEnabled ? (
                              this.CountDoughnut(nmuaUcChartData)
                            ) : (
                              <div style={{ width: "9rem" }}>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={nmuaUcChart}
                                />
                              </div>
                            )}
                          </div>
                          <div className="col-12  ">
                            <div className="outer-legend-block">
                              <Scrollbars
                                style={{
                                  height: `6rem`,
                                  margin: "0.5rem 0.2rem 0.5rem 0",
                                }}
                                renderView={(props) => (
                                  <div
                                    style={{
                                      paddingRight: "15px",
                                      ...props.style,
                                      overflowX: "hidden",
                                    }}
                                  />
                                )}
                              >
                                <div className="clide-v2-graph-left-box my-2 d-flex align-items-center  ">
                                  <span
                                    className="soi-kanban-modal-legend-box clide-v2-square-span "
                                    style={{
                                      backgroundColor: reportData.nm_ua_color,
                                    }}
                                  ></span>
                                  <span className="sm-graph-modal-legend-text ">
                                    {t("unsafeAct")}
                                  </span>
                                  <span className=" ml-auto">
                                    {reportData.nm_ua_number}
                                  </span>
                                </div>
                                <div className="soi-kanban-inner-legend-block  ">
                                  <span
                                    className="soi-kanban-modal-legend-box clide-v2-square-span"
                                    style={{
                                      backgroundColor: reportData.nm_ua_color,
                                    }}
                                  ></span>
                                  <span className="sm-graph-modal-legend-text my-2">
                                    {t("unsafeCond")}
                                  </span>
                                  <span className="legend-number float-end">
                                    {reportData.nm_uc_number}
                                  </span>
                                </div>
                              </Scrollbars>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {reportData.ua_number == 0 && reportData.uc_number == 0 ? (
                    <div className="graph-not-available-text">
                      {t("graphNA")}
                    </div>
                  ) : (
                    <div className="col-12  mb-3">
                      <div className="clide-v2-white-box">
                        <div className="row align-items-center">
                          <div className="col-12 my-2">
                            <div className="sm-graph-modal-legend-text text-center mb-3">
                              <b>{t("uaUC")}</b>
                            </div>
                            {config.isChartJsEnabled ? (
                              this.CountDoughnut(uaUcChartData)
                            ) : (
                              <div style={{ width: "9rem" }}>
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={uaUcChart}
                                />
                              </div>
                            )}
                          </div>
                          <div className="col-12 ">
                            <div className="outer-legend-block">
                              <Scrollbars
                                style={{
                                  height: `6rem`,
                                  margin: "0.5rem 0.2rem 0.5rem 0",
                                }}
                                renderView={(props) => (
                                  <div
                                    style={{
                                      paddingRight: "15px",
                                      ...props.style,
                                      overflowX: "hidden",
                                    }}
                                  />
                                )}
                              >
                                <div className="clide-v2-graph-left-box my-2 d-flex align-items-center  ">
                                  <span
                                    className="soi-kanban-modal-legend-box clide-v2-square-span "
                                    style={{
                                      backgroundColor: "#C7AC83",
                                    }}
                                  ></span>
                                  <span className="sm-graph-modal-legend-text ">
                                    {t("unsafeAct")}
                                  </span>
                                  <span className=" ml-auto">
                                    {reportData.ua_number}{" "}
                                  </span>
                                </div>
                                <div className="soi-kanban-inner-legend-block  ">
                                  <span
                                    className="soi-kanban-modal-legend-box clide-v2-square-span"
                                    style={{
                                      backgroundColor: "#554040",
                                    }}
                                  ></span>
                                  <span className="sm-graph-modal-legend-text my-2">
                                    {t("unsafeCond")}
                                  </span>
                                  <span className="legend-number float-end">
                                    {reportData.uc_number}
                                  </span>
                                </div>
                              </Scrollbars>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="clide-v2-card-box-1 p-3 mt-2">
              <div className="clide-v2-card-box-1">
                {/* {reportData.extreme_number == 0 &&
                  reportData.high_number == 0 &&
                  reportData.medium_number == 0 &&
                  reportData.low_number == 0 ? (
                  <div className="graph-not-available-text">
                    {t('graphNA')}
                  </div>
                ) : ( */}
                <div className="col-12  mb-3">
                  <div className="row align-items-center">
                    <div className="col-12  col-md-12 ">
                      <div className="outer-legend-block">
                        <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold text-center pt-3 w-space-nobreak">
                          {t("riskAnalysis")}
                        </p>
                      </div>
                      <hr />
                    </div>
                    <div className="col-12  col-md-12 my-2">
                      {config.isChartJsEnabled ? (
                        <Bar
                          data={severityChartData}
                          plugins={[ChartDataLabels]}
                          options={barGraphOptions}
                          height={150}
                        />
                      ) : (
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={severityChart}
                        />
                      )}
                    </div>
                  </div>
                  {/* </div> */}
                </div>
                {/* )} */}
              </div>

              <div className="clide-v2-card-box-1 p-3 mt-2">
                <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold text-center pt-3 w-space-nobreak">
                  {" "}
                  {t("goodAct")}{" "}
                </p>
                <hr />
                <div className="row">
                  <div className="col-12 col-lg-6 col-md-12 my-2">
                    {config.isChartJsEnabled ? (
                      <CountGraph
                        count={this.state.gpcount.map((data) => data?.ga_count)}
                        radius={"77%"}
                        cutout={"82%"}
                        height={100}
                        fontWeight={500}
                        fontSize={"1.5rem"}
                        color={this.state.gpcount.map((data) => data.color)}
                      />
                    ) : (
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={gpCount}
                      />
                    )}
                    <div class="w-100 text-center">
                      <span class="font-weight-bold fs-5">{t("ga")}</span>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 col-md-12 my-2">
                    {config.isChartJsEnabled ? (
                      <CountGraph
                        count={this.state.tbtcount.map(
                          (data) => data.tbt_count,
                        )}
                        radius={"77%"}
                        cutout={"82%"}
                        height={100}
                        fontWeight={500}
                        fontSize={"1.5rem"}
                        color={this.state.tbtcount.map((data) => data.color)}
                      />
                    ) : (
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={tbtCount}
                      />
                    )}
                    <div class="w-100 text-center">
                      <span class="font-weight-bold fs-5">{t("tbt")} </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="clide-v2-card-box-1 p-3 mt-2">
                <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold text-center pt-3 w-space-nobreak">
                  {t("internalExternal")}
                </p>
                <hr />
                <div className="row">
                  <div className="col-12 col-lg-6 col-md-12 my-2">
                    {config.isChartJsEnabled ? (
                      <CountGraph
                        count={this.state.trainingInternalCount.map(
                          (data) => data.training_internal_count,
                        )}
                        radius={"77%"}
                        cutout={"75%"}
                        height={100}
                        fontWeight={500}
                        fontSize={"1.5rem"}
                        color={this.state.trainingInternalCount.map(
                          (data) => data.color,
                        )}
                      />
                    ) : (
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={internalCount}
                      />
                    )}
                    <div class="w-100 text-center">
                      <span class="font-weight-bold fs-5">{t("internal")}</span>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 col-md-12 my-2">
                    {config.isChartJsEnabled ? (
                      <CountGraph
                        count={
                          this.state.trainingExternalCount.map(
                            (data) => data.training_external_count,
                          ) ?? 0
                        }
                        radius={"77%"}
                        cutout={"75%"}
                        height={100}
                        fontWeight={500}
                        fontSize={"1.5rem"}
                        color={this.state.trainingExternalCount.map(
                          (data) => data.color,
                        )}
                      />
                    ) : (
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={externalCount}
                      />
                    )}
                    <div class="w-100 text-center">
                      <span class="font-weight-bold fs-5">{t("external")}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="clide-v2-card-box-1 p-3 mt-2">
                <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold text-center pt-3 w-space-nobreak">
                  {t("employeeContractor")}
                </p>
                <hr />
                <div className="row">
                  <div className="col-12 col-lg-6 col-md-12 my-2">
                    {config.isChartJsEnabled ? (
                      <CountGraph
                        count={
                          this.state.trainingEmployeeCount.map(
                            (data) => data.training_employee_count,
                          ) ?? 0
                        }
                        radius={"77%"}
                        cutout={"75%"}
                        height={100}
                        fontWeight={500}
                        fontSize={"1.5rem"}
                        color={this.state.trainingEmployeeCount.map(
                          (data) => data.color,
                        )}
                      />
                    ) : (
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={employeeCount}
                      />
                    )}
                    <div class="w-100 text-center">
                      <span class="font-weight-bold fs-5">{t("employee")}</span>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 col-md-12 my-2">
                    {config.isChartJsEnabled ? (
                      <CountGraph
                        count={
                          this.state.trainingContractorCount.map(
                            (data) => data.training_contractor_count,
                          ) ?? 0
                        }
                        radius={"77%"}
                        cutout={"75%"}
                        height={100}
                        fontWeight={500}
                        fontSize={"1.5rem"}
                        color={this.state.trainingContractorCount.map(
                          (data) => data.color,
                        )}
                      />
                    ) : (
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={contractorCount}
                      />
                    )}
                    <div class="w-100 text-center">
                      <span class="font-weight-bold fs-5">{t("contract")}</span>
                    </div>
                  </div>
                </div>
              </div>

              <Modal
                centered
                show={this.state.deletePopup}
                className="submit-modal"
              >
                <Modal.Header
                  closeButton
                  onClick={this.hideModal}
                ></Modal.Header>

                <Modal.Body className="text-center p-0">
                  <img
                    className="submit-img"
                    src={require("assets/images/delete-popup.svg")}
                  />
                  <p className="submit-text">{t("wantDelete")}</p>
                  <div className="modal-footer-btn my-4">
                    <button
                      type="submit"
                      className="red-btn"
                      onClick={this.hideModal}
                    >
                      {t("cancel")}
                    </button>
                    <button
                      type="submit"
                      className="red-btn"
                      onClick={() => this.deleteReport(this.state.soiId)}
                    >
                      {t("yesDelete")}
                    </button>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
        {this.state.show ? (
          <ResolvePopup
            show={this.state.show}
            modalClose={this.openResolve}
            reportId={this.state.soiId}
            reportingDetails
            data={this.state.reportDetail}
          />
        ) : null}
        {this.state.showUser ? (
          <InviteUser
            showUser={this.state.showUser}
            closeUser={this.openInviteUser}
            reportId={this.state.soiId}
            onAddNewUsers={this._addUsersToList}
            invitedUsersList={[...this.state.reportDetail.invited_user]}
            removeInviteUser={this.removeInviteUser}
            resolveFlag={this.state.resolveFlag}
            moduleType={"report"}
          />
        ) : null}
        <Modal
          show={this.state.userLikedPopup}
          onHide={this.handleClose}
          className="likeduser"
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("userLiked")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="totalLikedUser">
              <span>{t("all")}</span>
              <span className="count">{this.state.likeNumber}</span>
            </div>
            {this.state.userLike != "" ? (
              this.state.userLike.map((items, index) => (
                <div className="user-list" key={index}>
                  <img src={items.user_profile} alt={items.user_name} />
                  <h6 className="user-name">{items.user_name}</h6>
                </div>
              ))
            ) : (
              <div className="user-list">
                <p className="data-not-present">{t("likeNot")}</p>
              </div>
            )}
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.countModalParams.isOpen}
          className="reportPopup "
          dialogClassName="modal-xl"
          onHide={() =>
            this.setState({
              countModalParams: {
                isOpen: false,
                moduleName: "",
              },
            })
          }
        >
          <Modal.Header closeButton>
            <Modal.Title className="clide-v2-fs-4 clide-v2-primary-color">
              {this.state.countModalParams.moduleName} wise &nbsp;{" "}
              {this.state?.reportData?.activity} | {t("analysis")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Bar
              plugins={[ChartDataLabels]}
              options={barGraphOptions}
              {...this.generateBarData(this.state.countModalParams.moduleData)}
              height={150}
            />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

// Page Help: Append help drawer when viewing UAUC detail
ReportingDetail.prototype.render = (function (original) {
  return function wrappedRender() {
    const output = original.apply(this, arguments);
    const screenFlag =
      this &&
      this.state &&
      (this.state.reportingScreen || this.state.resolveFlag);
    const isOpenDetail = screenFlag === "open";
    const isOnHoldDetail = screenFlag === "onHold" || screenFlag === "onhold";
    const isResolvedDetail =
      screenFlag === "resolve" || screenFlag === "resolved";
    return (
      <>
        {output}
        {isOpenDetail && <UaucOpenDetailHelpDrawer />}
        {isOnHoldDetail && <UaucOnHoldDetailHelpDrawer />}
        {isResolvedDetail && <UaucResolvedDetailHelpDrawer />}
      </>
    );
  };
})(ReportingDetail.prototype.render);

// This comment is to remove

export default withTranslation(["uauc", "util"])(withRouter(ReportingDetail));

export const GetPopoverFrame = ({
  element,
  mappingKeys = {},
  position = "right",
  triggerType = null,
  customElement = "",
  returnTriggerOnly = false,
  isManualTrigger = false,
  extractTrigger = () => {},
  viewContainerClasses = "d-flex-center position-relative",
  viewProps = {
    top: "-13px",
    right: "25%",
    marginLeft: "127px",
  },
}) => {
  const [isModalEnabled, setIsModalEnabled] = useState(false);
  const elements = mappingKeys() ?? {};
  extractTrigger(setIsModalEnabled);
  return (
    <>
      {returnTriggerOnly ? (
        <div title="User Details">
          {" "}
          <Eye
            className="cursor-p w-10 position-absolute d-flex"
            style={viewProps}
            id="properover-content"
            title="user details"
            onClick={() => setIsModalEnabled(true)}
          />{" "}
        </div>
      ) : (
        <div className={viewContainerClasses} id="properover-content">
          <div>{element}</div>
          {!isManualTrigger ? (
            <div title="User Details">
              <Eye
                className="cursor-p w-10 position-absolute"
                style={viewProps}
                onClick={() => setIsModalEnabled(true)}
              />
            </div>
          ) : null}
        </div>
      )}

      <SLDModal
        style={{
          maxWidth: "auto",
        }}
        isOpen={isModalEnabled}
        footer={[
          <SLDButton
            label={t("close")}
            onClick={() => setIsModalEnabled(false)}
          />,
        ]}
        // onRequestClose={() => setIsModalEnabled(false)}
        heading={t("userDetails")}
      >
        <Container>
          {elements &&
            Object?.entries(elements)?.map((el) => (
              <div className="my-3">
                <span className="common-black-1 font-weight-500 font-18">
                  {el[0]} :
                </span>
                <span className="common-black-1 ml-3 font-18">{el[1]}</span>
              </div>
            ))}
          {customElement}
        </Container>
      </SLDModal>
    </>
  );
};
